var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 0
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "sun",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 3,
    x2: 15,
    y2: 0,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 6.5,
    x2: 26,
    y2: 4,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 15,
    x2: 30,
    y2: 15,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 24,
    x2: 26,
    y2: 26,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 27,
    x2: 15,
    y2: 30,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 24,
    x2: 5,
    y2: 26,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 15,
    x2: 0,
    y2: 15,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 6.5,
    x2: 5,
    y2: 4,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "moon",
    transform: "translate(1.000000, 2.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5884232,19.6466202 C18.72582,19.645548 14.1515533,17.3601559 11.2587189,13.4864616 C8.36588457,9.61276739 7.49694369,4.6093487 8.91653278,0 C2.51525175,2.92427092 -1.0501789,9.79686907 0.274447544,16.6581781 C1.59907399,23.5194872 7.47255605,28.6021494 14.5109136,28.977812 C21.5492712,29.3534745 27.9395418,24.925373 30,18.2447381 C27.9909169,19.1680378 25.8029859,19.6464257 23.5884232,19.6466202 L23.5884232,19.6466202 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 3,
    x2: 21,
    y2: 3,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 6,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 9,
    x2: 29,
    y2: 9,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 6,
    x2: 26,
    y2: 12,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tech",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,15 L2.66666667,15 C1.19390733,15 0,13.8060927 0,12.3333333 L0,9.66666667 C0,8.19390733 1.19390733,7 2.66666667,7 L3.33333333,7 C3.70152317,7 4,7.29847683 4,7.66666667 L4,14.3333333 C4,14.7015232 3.70152317,15 3.33333333,15 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3333333,15 L18.6666667,15 C18.2984768,15 18,14.7015232 18,14.3333333 L18,7.66666667 C18,7.29847683 18.2984768,7 18.6666667,7 L19.3333333,7 C20.8060927,7 22,8.19390733 22,9.66666667 L22,12.3333333 C22,13.8060927 20.8060927,15 19.3333333,15 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,7 C4,3.13400675 7.13400675,0 11,0 L11,0 C12.8565154,0 14.6369928,0.737497883 15.9497475,2.05025253 C17.2625021,3.36300718 18,5.14348457 18,7",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19 L16.7142857,19 C17.9766509,19 19,17.9254834 19,16.6 L19,15",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3333333,21 L10.6666667,21 C9.74619208,21 9,20.1045695 9,19 L9,19 C9,17.8954305 9.74619208,17 10.6666667,17 L12.3333333,17 C13.2538079,17 14,17.8954305 14,19 L14,19 C14,20.1045695 13.2538079,21 12.3333333,21 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pig",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,6 C22,7.65685425 21.6568542,9 20,9",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,5.70179806 C9.57545916,4.76606731 11.4245408,4.76606731 13,5.70179806",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,2.18769231 C6.12923077,0.00615384615 3.07692308,0 3.07692308,0 L3.71897436,4.49641026 C2.87941388,5.41133906 2.25681397,6.50369341 1.8974359,7.69230769 L0,7.69230769 L0,13.8461538 L2.55384615,13.8461538 C3.08496919,14.7773906 3.78393027,15.6022342 4.61538462,16.2789744 L4.61538462,19.2307692 C4.61538462,19.6556037 4.95978096,20 5.38461538,20 L6.92307692,20 C7.34791135,20 7.69230769,19.6556037 7.69230769,19.2307692 L7.69230769,17.9579487 C9.68865469,18.6255103 11.8473726,18.6294679 13.8461538,17.9692308 L13.8461538,19.2307692 C13.8461538,19.6556037 14.1905502,20 14.6153846,20 L16.1538462,20 C16.5786806,20 16.9230769,19.6556037 16.9230769,19.2307692 L16.9230769,16.294359 C18.8448454,14.7671236 19.9752982,12.454594 20,10 C20,3.33948718 12.7692308,0.37025641 7.33333333,2.18769231 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "spreadsheet",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 22,
    x2: 15,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 19,
    x2: 11,
    y2: -3,
    id: "Path",
    transform: "translate(11.000000, 8.000000) rotate(90.000000) translate(-11.000000, -8.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 26,
    x2: 11,
    y2: 4,
    id: "Path",
    transform: "translate(11.000000, 15.000000) rotate(90.000000) translate(-11.000000, -15.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "rolodex",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,2 L18.5,2 C19.3284271,2 20,2.67157288 20,3.5 L20,10.5 C20,11.3284271 19.3284271,12 18.5,12 L3.5,12 C2.67157288,12 2,11.3284271 2,10.5 L2,3.5 C2,2.67157288 2.67157288,2 3.5,2 Z",
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,19 L18.5,19 C19.3284271,19 20,19.6715729 20,20.5 C20,21.3284271 19.3284271,22 18.5,22 L3.5,22 C2.67157288,22 2,21.3284271 2,20.5 C2,19.6715729 2.67157288,19 3.5,19 Z",
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13145212,12 L18.8685479,12 C19.5382684,12 20.1268474,12.443966 20.3108338,13.0879183 L21.4536909,17.0879183 C21.6812774,17.8844708 21.2200392,18.7146995 20.4234867,18.9422859 C20.2894745,18.9805751 20.1507798,19 20.011405,19 L1.98859498,19 C1.16016785,19 0.488594976,18.3284271 0.488594976,17.5 C0.488594976,17.3606252 0.508019855,17.2219305 0.546309055,17.0879183 L1.6891662,13.0879183 C1.87315258,12.443966 2.46173158,12 3.13145212,12 Z",
    id: "Rectangle-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 6,
    y2: 10,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 10,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 6,
    x2: 20,
    y2: 6,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 2,
    x2: 6,
    y2: 0,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 0,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "question",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49253422,9 C3.88121898,9 4.23375309,9.14458203 4.52940099,9.42172887 C4.83710427,9.7101767 5,10.0798764 5,10.5 C5,10.917489 4.8416476,11.2856429 4.54109052,11.5742637 C4.24875589,11.8549885 3.89149148,12 3.49253422,12 C3.09199111,12 2.73529976,11.853713 2.44715626,11.5700953 C2.15380731,11.281354 2,10.9148273 2,10.5 C2,10.0851727 2.15380731,9.718646 2.44715626,9.42990466 C2.73529976,9.14628701 3.09199111,9 3.49253422,9 Z M3.55180617,0 C4.56162173,0 5.39594783,0.273366414 6.03106434,0.825765431 C6.67530051,1.38609637 7,2.13166053 7,3.02994542 C7,3.50844273 6.91255332,3.93233729 6.7332519,4.29829815 C6.56216325,4.64749643 6.35245085,4.94009559 6.10250605,5.17353321 C5.92245197,5.34169593 5.70495583,5.5184154 5.45158775,5.70313467 L5.25486023,5.84316538 C4.93459882,6.07078102 4.70435353,6.26326217 4.56764518,6.41387323 C4.49837167,6.4901916 4.45779176,6.57673847 4.44433074,6.68402864 L4.43929515,6.76854993 L4.43682657,7.38118079 L4.42145213,7.49454826 C4.39357593,7.61456401 4.33292401,7.72336628 4.241538,7.81079858 C4.13435217,7.91334714 4.00067124,7.97290691 3.85525808,7.99262888 L3.74422907,8 L2.70424731,7.99763821 L2.58575334,7.98292893 C2.46031044,7.95625877 2.3465881,7.89823089 2.25520209,7.81079858 C2.14801625,7.70825002 2.08576318,7.58035265 2.06514938,7.44123062 L2.05744493,7.33500516 L2.05777647,6.68080181 L2.06578604,6.48558141 C2.10055103,6.0531895 2.24471397,5.67689166 2.50029964,5.36857369 C2.71284515,5.11217591 2.99776597,4.84855416 3.35461316,4.57566049 L3.57734905,4.41079528 C3.95590528,4.13695305 4.23677414,3.89424057 4.41814366,3.68766583 C4.55001951,3.53746298 4.61814978,3.33881099 4.61814978,3.07242956 C4.61814978,2.77171661 4.52582903,2.5576369 4.33842027,2.39657014 C4.13911179,2.22527627 3.86984681,2.13718838 3.50740088,2.13718838 C3.13677238,2.13718838 2.86163774,2.22881951 2.65770621,2.40766911 C2.49025252,2.55452736 2.39631783,2.73738443 2.37289677,2.97644492 L2.36704846,3.10075232 L2.36482037,3.44201558 L2.35038072,3.553548 C2.28681739,3.83734356 2.06153539,4.008062 1.76992932,4.04234994 L1.65765442,4.04876712 L0.640844332,4.01766907 L0.516196144,4.00005859 C0.385030215,3.9686858 0.268708342,3.90191219 0.178692455,3.80502556 C0.0828024452,3.70181644 0.0259732799,3.57761071 0.00707721414,3.4436345 L0,3.3414958 L0.000278397573,3.08522757 L0.00900209263,2.85031654 C0.045615242,2.34845699 0.194092291,1.89088126 0.454366719,1.48383923 C0.758296639,1.00852456 1.18859487,0.638851047 1.73605231,0.379721583 C2.27253141,0.125788528 2.87956222,0 3.55180617,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "license",
    transform: "translate(1.000000, 1.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0683594,16 C18.5866383,16 19.4082963,16 20.5333333,16 C21.343351,16 22,15.4030463 22,14.6666667 L22,1.33333333 C22,0.596953667 21.343351,0 20.5333333,0 L1.46666667,0 C0.656649034,0 0,0.596953667 0,1.33333333 L0,14.6666667 C0,15.4030463 0.656649034,16 1.46666667,16 C5.7037037,16 8.88148148,16 11,16",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 18,
    y2: 5,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10,
    x2: 13,
    y2: 10,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ribbon",
    transform: "translate(11.000000, 10.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60966185,6 L1.00907785,11.2149664 C0.965126029,11.5014086 1.08367376,11.7883979 1.30182909,11.9236807 C1.51998442,12.0589636 1.78721687,12.0112049 1.96175423,11.8057416 L3.5,9.98728933 L5.03824577,11.8057416 C5.21278313,12.0112049 5.48001558,12.0589636 5.69817091,11.9236807 C5.91632624,11.7883979 6.03487397,11.5014086 5.99092215,11.2149664 L5.39033815,6",
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "license-trial",
    transform: "translate(1.000000, 1.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0683594,16 C18.5866383,16 19.4082963,16 20.5333333,16 C21.343351,16 22,15.4030463 22,14.6666667 L22,1.33333333 C22,0.596953667 21.343351,0 20.5333333,0 L1.46666667,0 C0.656649034,0 0,0.596953667 0,1.33333333 L0,14.6666667 C0,15.4030463 0.656649034,16 1.46666667,16 C5.7037037,16 8.88148148,16 11,16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ribbon",
    transform: "translate(11.000000, 10.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60966185,6 L1.00907785,11.2149664 C0.965126029,11.5014086 1.08367376,11.7883979 1.30182909,11.9236807 C1.51998442,12.0589636 1.78721687,12.0112049 1.96175423,11.8057416 L3.5,9.98728933 L5.03824577,11.8057416 C5.21278313,12.0112049 5.48001558,12.0589636 5.69817091,11.9236807 C5.91632624,11.7883979 6.03487397,11.5014086 5.99092215,11.2149664 L5.39033815,6",
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.87866211,8 L4.49731445,4.48974609 L5.63208008,4.48974609 L5.8371582,3.33789062 L2.13208008,3.33789062 L1.92700195,4.48974609 L3.06860352,4.48974609 L2.44311523,8 L3.87866211,8 Z M6.89331055,8 L7.1496582,6.53027344 L7.53930664,6.53027344 L7.53930664,6.53027344 L8.0144043,8 L9.50463867,8 L8.92358398,6.35595703 C9.23347982,6.22835286 9.47558594,6.04093424 9.64990234,5.79370117 C9.82421875,5.5464681 9.92390951,5.25878906 9.94897461,4.93066406 C9.95125326,4.9078776 9.95296224,4.88110352 9.95410156,4.8503418 C9.95524089,4.81958008 9.95581055,4.78710938 9.95581055,4.75292969 C9.95581055,4.28808594 9.80826823,3.93546549 9.51318359,3.69506836 C9.21809896,3.45467122 8.82332357,3.33447266 8.32885742,3.33447266 L6.2746582,3.33447266 L5.4543457,8 L6.89331055,8 Z M7.81616211,5.52197266 L7.32397461,5.52197266 L7.5324707,4.390625 L7.97338867,4.390625 C8.04630534,4.390625 8.12491862,4.40315755 8.20922852,4.42822266 C8.29353841,4.45328776 8.36645508,4.5 8.42797852,4.56835938 C8.48950195,4.63671875 8.52026367,4.73697917 8.52026367,4.86914062 C8.52026367,4.88964844 8.51912435,4.91015625 8.5168457,4.93066406 C8.51456706,4.95117188 8.51228841,4.9671224 8.51000977,4.97851562 C8.49405924,5.09700521 8.45304362,5.19669596 8.38696289,5.27758789 C8.32088216,5.35847982 8.23885091,5.41943359 8.14086914,5.46044922 C8.04288737,5.50146484 7.93465169,5.52197266 7.81616211,5.52197266 Z M11.5075684,8 L12.3278809,3.33789062 L10.895752,3.33789062 L10.0754395,8 L11.5075684,8 Z M13.3601074,8 L13.7121582,7.11816406 L14.9460449,7.11816406 L14.9904785,8 L16.5422363,8 L15.9440918,3.33789062 L14.1291504,3.33789062 L11.9177246,8 L13.3601074,8 Z M14.9016113,6.10986328 L14.1257324,6.10986328 L14.7648926,4.52392578 L14.8400879,4.52392578 L14.9016113,6.10986328 Z M20.083252,8 L20.2883301,6.82763672 L18.5930176,6.82763672 L19.208252,3.33789062 L17.776123,3.33789062 L16.9558105,8 L20.083252,8 Z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "license-nfr",
    transform: "translate(1.000000, 1.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0683594,16 C18.5866383,16 19.4082963,16 20.5333333,16 C21.343351,16 22,15.4030463 22,14.6666667 L22,1.33333333 C22,0.596953667 21.343351,0 20.5333333,0 L1.46666667,0 C0.656649034,0 0,0.596953667 0,1.33333333 L0,14.6666667 C0,15.4030463 0.656649034,16 1.46666667,16 C5.7037037,16 8.88148148,16 11,16",
    id: "Path",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ribbon",
    transform: "translate(11.000000, 10.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60966185,6 L1.00907785,11.2149664 C0.965126029,11.5014086 1.08367376,11.7883979 1.30182909,11.9236807 C1.51998442,12.0589636 1.78721687,12.0112049 1.96175423,11.8057416 L3.5,9.98728933 L5.03824577,11.8057416 C5.21278313,12.0112049 5.48001558,12.0589636 5.69817091,11.9236807 C5.91632624,11.7883979 6.03487397,11.5014086 5.99092215,11.2149664 L5.39033815,6",
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.79614258,8 L6.19604492,5.68603516 L6.25073242,5.68603516 L7.42993164,8 L8.49975586,8 L9.32006836,3.33789062 L7.99047852,3.33789062 L7.59741211,5.61083984 L7.54272461,5.61083984 L6.3737793,3.33789062 L5.28686523,3.33789062 L4.46655273,8 L5.79614258,8 Z M10.7419434,8 L11.0256348,6.38671875 L12.7312012,6.38671875 L12.9191895,5.31005859 L11.217041,5.31005859 L11.3674316,4.45898438 L13.2473145,4.45898438 L13.4455566,3.33789062 L10.130127,3.33789062 L9.30981445,8 L10.7419434,8 Z M14.6315918,8 L14.8879395,6.53027344 L15.2775879,6.53027344 L15.2775879,6.53027344 L15.7526855,8 L17.2429199,8 L16.6618652,6.35595703 C16.9717611,6.22835286 17.2138672,6.04093424 17.3881836,5.79370117 C17.5625,5.5464681 17.6621908,5.25878906 17.6872559,4.93066406 C17.6895345,4.9078776 17.6912435,4.88110352 17.6923828,4.8503418 C17.6935221,4.81958008 17.6940918,4.78710938 17.6940918,4.75292969 C17.6940918,4.28808594 17.5465495,3.93546549 17.2514648,3.69506836 C16.9563802,3.45467122 16.5616048,3.33447266 16.0671387,3.33447266 L14.0129395,3.33447266 L13.192627,8 L14.6315918,8 Z M15.5544434,5.52197266 L15.0622559,5.52197266 L15.270752,4.390625 L15.7116699,4.390625 C15.7845866,4.390625 15.8631999,4.40315755 15.9475098,4.42822266 C16.0318197,4.45328776 16.1047363,4.5 16.1662598,4.56835938 C16.2277832,4.63671875 16.2585449,4.73697917 16.2585449,4.86914062 C16.2585449,4.88964844 16.2574056,4.91015625 16.255127,4.93066406 C16.2528483,4.95117188 16.2505697,4.9671224 16.248291,4.97851562 C16.2323405,5.09700521 16.1913249,5.19669596 16.1252441,5.27758789 C16.0591634,5.35847982 15.9771322,5.41943359 15.8791504,5.46044922 C15.7811686,5.50146484 15.6729329,5.52197266 15.5544434,5.52197266 Z",
    id: "NFR",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,13 L2,21.25 C2,21.6630865 2.4025394,22 2.9,22 L19.1,22 C19.5974606,22 20,21.6630865 20,21.25 L20,13",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.916666667,7 L21.0833333,7 C21.5900062,7 22,7.447266 22,8 L22,12 C22,12.550782 21.5900062,13 21.0833333,13 L0.916666667,13 C0.409993833,13 0,12.550782 0,12 L0,8 C0,7.447266 0.409993833,7 0.916666667,7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 22,
    x2: 11,
    y2: 7,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6773252,4.15914534 C14.9952992,5.47755349 13.064303,6.44281711 11,7 C11.5547935,4.93214135 12.5193119,2.99965133 13.8386636,1.31828867 C15.6030252,-0.447436028 16.6028307,-0.174729956 17.3928714,0.606113219 C18.1809529,1.38695639 18.4416868,2.39145784 16.6773252,4.15914534 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32267481,4.15914534 C7.00470078,5.47755349 8.93569696,6.44281711 11,7 C10.4452065,4.93214135 9.48068806,2.99965133 8.1613364,1.31828867 C6.3969748,-0.447436028 5.39716935,-0.174729956 4.60712859,0.606113219 C3.81904709,1.38695639 3.55831321,2.39145784 5.32267481,4.15914534 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shop",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,12 L20,20.5714286 C20,21.3604068 19.3800866,22 18.6153846,22 L3.38461538,22 C2.61991342,22 2,21.3604068 2,20.5714286 L2,12",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9447111,0 L2.05528889,0 C1.71147943,0 1.41365734,0.243863525 1.33857778,0.587000336 L0,6.75000009 C0,7.99264071 0.984973563,9 2.2,9 C3.41502644,9 4.39999998,7.99264071 4.4,6.75000009 C4.40000003,7.99264071 5.38497357,9 6.6,9 C7.81502643,9 8.79999997,7.99264071 8.8,6.75000009 C8.8,7.99264073 9.78497355,9 11,9 C12.2150264,9 13.2,7.99264073 13.2,6.75000009 C13.2,7.9926407 14.1849736,9 15.4,9 C16.6150264,9 17.6,7.9926407 17.6,6.75000009 C17.6000001,7.99264069 18.5849736,9 19.8,9 C21.0150264,9 22,7.99264069 22,6.75000009 L20.6604444,0.587000336 C20.5861059,0.243807744 20.2884126,-0.00034181911 19.9447111,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ids",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5333333,6 L1.46666667,6 C0.656649034,6 0,6.59695367 0,7.33333333 L0,20.6666667 C0,21.4030463 0.656649034,22 1.46666667,22 L4.4,22 C4.4,21.2636203 5.05664903,20.6666667 5.86666667,20.6666667 C6.6766843,20.6666667 7.33333333,21.2636203 7.33333333,22 L14.6666667,22 C14.6666667,21.2636203 15.3233157,20.6666667 16.1333333,20.6666667 C16.943351,20.6666667 17.6,21.2636203 17.6,22 L20.5333333,22 C21.343351,22 22,21.4030463 22,20.6666667 L22,7.33333333 C22,6.59695367 21.343351,6 20.5333333,6 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,2 C20,0.8954305 19.4627417,0 18.8,0 L3.2,0 C2.5372583,0 2,0.8954305 2,2",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 11,
    x2: 15,
    y2: 11,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 16,
    x2: 18,
    y2: 16,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blink",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7499761,10 C20.3365465,10 20.0010964,10.3345878 20,10.748016 C19.998909,11.1614441 20.3325843,11.4977888 20.746008,11.4999894 C21.1594318,11.5021899 21.4966686,11.1694164 21.4999761,10.756 C21.4999761,10.3417864 21.1641896,10.006 20.7499761,10.006 L20.7499761,10.006",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.749976056,10 C0.336546458,10 0.00109635034,10.3345878 0,10.748016 C-0.00109098868,11.1614441 0.332584291,11.4977888 0.746008033,11.4999894 C1.15943177,11.5021899 1.49666862,11.1694164 1.49997606,10.756 C1.49997606,10.3417864 1.16418962,10.006 0.749976056,10.006 L0.749976056,10.006",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7527584,0 C16.3751722,-0.000336920973 16.0558708,0.279363465 16.006511,0.653709643 C15.9571512,1.02805582 16.1930398,1.38096131 16.557812,1.47849401 C16.9225843,1.57602671 17.3031228,1.38794127 17.4471782,1.03891477 C17.5912336,0.68988827 17.4541336,0.288155436 17.1267584,0.10001478 C17.0133252,0.0337214032 16.8841403,-0.000820015815 16.7527584,0 L16.7527584,0",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74768803,20 C4.37231297,20.0001857 4.05521194,20.2785581 4.00640636,20.6507469 C3.95760077,21.0229356 4.1922083,21.3736542 4.55484439,21.4706158 C4.91748049,21.5675773 5.2958175,21.3807476 5.43927641,21.0338672 C5.58273531,20.6869868 5.44687926,20.2875029 5.12168803,20.1000005 C5.00799341,20.0343364 4.87898246,19.9998415 4.74768803,20 L4.74768803,20",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74701121,0 C4.61562931,-0.000820015815 4.4864444,0.0337214032 4.37301121,0.10001478 C4.04891218,0.287197736 3.91367801,0.685556893 4.05683858,1.0313642 C4.19999914,1.3771715 4.57723537,1.56337334 4.93880335,1.46669741 C5.30037133,1.37002148 5.53433832,1.02039632 5.48580977,0.64928634 C5.43728122,0.278176357 5.12128041,0.000468263414 4.74701121,0 L4.74701121,0",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7501631,20 C16.4108073,19.9999568 16.1137058,20.2277875 16.0257166,20.5555379 C15.9377275,20.8832883 16.0807774,21.2292837 16.3745268,21.3992064 C16.6682761,21.5691291 17.0395232,21.5206347 17.2797685,21.2809587 C17.5200137,21.0412826 17.5693886,20.6701516 17.4001631,20.376 C17.2663571,20.1434154 17.0184906,20.0000341 16.7501631,20 L16.7501631,20",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.5,
    cy: 10.5,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57142857,9 C1.59898304,9 0,10.3705569 0,12.0612245 L0,13.8979592 L1.42857143,13.8979592 L2.14285714,19 L5,19",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.5,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4285714,9 C20.401017,9 22,10.3705569 22,12.0612245 L22,13.8979592 L20.5714286,13.8979592 L19.8571429,19 L17,19",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11.6666667 C16,9.08933783 13.7614237,7 11,7 C8.23857625,7 6,9.08933783 6,11.6666667 L6,13.6666667 L8.14285714,13.6666667 L8.85714286,22 L13.1428571,22 L13.8571429,13.6666667 L16,13.6666667 L16,11.6666667 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "books",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 6,
    height: 22,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 6,
    y: 0,
    width: 6,
    height: 22,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3052193,1.35457515 L19.2739257,1.35036335 C20.102352,1.34918804 20.774877,2.01980746 20.7760523,2.84823375 C20.7760544,2.84972552 20.7760543,2.8512173 20.776052,2.85270908 L20.7494632,19.8442314 C20.7481696,20.6709103 20.0782722,21.3407098 19.2515931,21.3418826 L16.2828867,21.3460944 C15.4544604,21.3472698 14.7819354,20.6766503 14.7807601,19.848224 C14.780758,19.8467323 14.7807581,19.8452405 14.7807605,19.8437487 L14.8073492,2.85222641 C14.8086428,2.02554748 15.4785402,1.35574799 16.3052193,1.35457515 Z",
    id: "Rectangle-path",
    transform: "translate(17.778406, 11.348229) rotate(-8.267000) translate(-17.778406, -11.348229) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "admin",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "users-geomertic-close-up-single-user-man-single-man",
    transform: "translate(0.405405, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.0108108 C0,17.6908151 4.31243679,13.3783784 9.63243243,13.3783784 C14.9524281,13.3783784 19.2648649,17.6908151 19.2648649,23.0108108 L0,23.0108108 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5189189,5.88648649 C15.5189189,9.13701397 12.8829599,11.772973 9.63243243,11.772973 C6.38190496,11.772973 3.74594595,9.13701397 3.74594595,5.88648649 C3.74594595,2.63595902 6.38190496,0 9.63243243,0 C12.8829599,0 15.5189189,2.63595902 15.5189189,5.88648649 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56014549,2.89830045 C6.40176276,4.80889985 8.94156438,5.88753214 11.5942464,5.8864925 C12.9258125,5.88753214 14.2427468,5.61682868 15.4656141,5.0900545",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "internet-networks-servers-cloud-cloud-flash",
    transform: "translate(18.758108, 2.067568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15945946,0.194594595 L0.832949546,8.09515421 C0.731567124,8.21430527 0.708572368,8.381535 0.774419676,8.52368076 C0.840265914,8.66582554 0.981366065,8.75675676 1.13814354,8.75675676 L3.94864865,8.75675676 L3.94864865,15.1783784 L10.2751586,7.27886442 C10.376541,7.1597123 10.3995358,6.99248257 10.3336884,6.85033784 C10.2678422,6.7081931 10.1256964,6.61726187 9.96891892,6.61726187 L7.15945946,6.61726187 L7.15945946,0.194594595 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tech-support",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,2 C22.9463977,2.7796135 28,8.01363118 28,14.3540787 C28.001193,18.3257454 26.1833759,22.0579146 23.1111104,24.3955097 L23.1111104,30",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43551268,21 L3.43551268,20.3392651 L1.49990069,20.3794319 C1.30514425,20.3781408 0.23099963,20.2373164 0.116296675,20.0656799 C0.0015937197,19.8953333 -0.0306674806,19.6759494 0.0302688467,19.4746314 C2.36495176,11.6593772 4.04606763,3.2556553 12,2",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,30 L10,27.1958005 L7.25008327,27.1958005 C6.82578074,27.1958005 6.40416214,27.130077 6,27",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333333,0 L15.6666667,0 C16.4036466,0 17,0.496961111 17,1.11111111 L17,8.88888889 C17,9.50303777 16.4036466,10 15.6666667,10 L14.3333333,10 C13.597656,10 13,9.50303777 13,8.88888889 L13,1.11111111 C13,0.496961111 13.597656,0 14.3333333,0 Z",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2962742,10 C18.8349305,10.9020412 20.3686271,13.5578483 19.9234371,16.2811565 C19.4794413,19.00569 17.18546,21 14.5,21 C11.813346,21 9.52055874,19.00569 9.07656286,16.2811565 C8.63137293,13.5578483 10.1650696,10.9020412 12.7037247,10",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18 C11.7983367,21.4296127 8.08856555,24 5,24",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pre-sales",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1243688,13.4435269 L17.4014741,13.4435269 C17.4014741,13.4435269 21.8961651,13.454212 21.957179,13.4435269 L24.7943263,12.8972153 C25.413362,12.7783359 25.862069,12.2119876 25.862069,11.5508042 L25.862069,4.11882795 C25.862069,3.55648731 25.5341194,3.05024766 25.0358385,2.84454543 L18.4692167,0.141037988 C17.8095051,-0.130114004 17.0620845,-0.00455564927 16.5167718,0.468290959 L11.7462472,4.59167455 C11.3725375,4.91358496 11.2708476,5.46791039 11.5034632,5.91270788 C11.7360788,6.35750399 12.2369018,6.56320485 12.6945054,6.40425481 L18.052289,4.55293894",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13793103,11.2188155 L7.77824791,11.9458605 L12.7983852,17.1587167 C13.1211184,17.4938394 13.5778676,17.6457802 14.0264109,17.5648397 L14.7265772,17.4384589 C15.3118728,17.3347983 15.7699901,16.8590942 15.8698184,16.2513296 L16.1132354,14.7787798 L18.5063811,14.3499367 L18.91937,11.8663392 L21.3125158,11.4374976 L21.7241379,8.95247947 L18.0838196,5.17241379",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5172414,3.02182997 L13.4311264,0.50167979 C13.0276742,0.0119750864 12.4204275,-0.134604236 11.8930472,0.130237368 L7.66298377,2.25062809 L4.13793103,3.10344828",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2.75862069,0 C3.52101241,0 4.13793103,0.647460666 4.13793103,1.44444445 L4.13793103,11.5555556 C4.13793103,12.3539491 3.52101241,13 2.75862069,13 L0,13 L0,0 Z",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2413793,1.03448276 L30,1.03448276 L30,14.0344828 L27.2413793,14.0344828 C26.4789876,14.0344828 25.862069,13.3884319 25.862069,12.5900383 L25.862069,2.47892721 C25.862069,1.68194343 26.4789876,1.03448276 27.2413793,1.03448276 Z",
    id: "Path",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tag",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8785,1.5002 L21.8785,7.7572 C21.8785,8.5522 21.5625,9.3152 21.0005,9.8782 L9.4395,21.4392 C8.8535,22.0252 7.9035,22.0252 7.3175,21.4392 L0.4395,14.5602 C-0.1465,13.9742 -0.1465,13.0242 0.4395,12.4382 L12.0005,0.8782 C12.5635,0.3152 13.3255,0.0002 14.1205,0.0002 L20.3785,0.0002 C21.2065,0.0002 21.8785,0.6712 21.8785,1.5002 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6285,3.7502 C15.7995,3.7502 15.1285,4.4212 15.1285,5.2502 C15.1285,6.0782 15.7995,6.7502 16.6285,6.7502 C17.4565,6.7502 18.1285,6.0782 18.1285,5.2502 C18.1285,4.4212 17.4565,3.7502 16.6285,3.7502 Z",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cert",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.65134885,13 L0.611797742,16.0011682 C0.263278237,16.2478688 0.0413228542,16.6357388 0.00520005439,17.0612058 C-0.0309227454,17.4866728 0.122465544,17.90641 0.424405845,18.2083356 L3.79166437,21.5755942 C4.09358999,21.8775345 4.51332725,22.0309227 4.93879424,21.9947999 C5.36426124,21.9586771 5.75213124,21.7367218 5.99883183,21.3882023 L9,17.3486511",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3486511,9 L21.3882023,5.99864327 C21.7367218,5.75192719 21.9586771,5.36403282 21.9947999,4.93853909 C22.0309227,4.51304536 21.8775345,4.09328174 21.5755942,3.79133715 L18.2083356,0.424833065 C17.9065437,0.122771422 17.4868933,-0.030791109 17.0614327,0.00514721103 C16.6359721,0.0410855311 16.2480226,0.262865374 16.0011682,0.611270738 L13,4.65107564",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "12 15.3006827 17 22 17 17 22 17 15.3006827 12"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.5,
    cy: 11.5,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "mfd-sml",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "2.47302179e-14 22 2.47302179e-14 1 7.625 1 10.5 3.8 22 3.8 22 22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 4,
    x2: 22,
    y2: 0,
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.383333333,
    y1: 16,
    x2: 22,
    y2: 16,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.383333333,
    y1: 10,
    x2: 22,
    y2: 10,
    id: "Line",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51362946,1 C4.07301176,0.996771188 3.65343577,1.25019171 3.36558556,1.69347201 C3.07773535,2.13675232 2.95052174,2.72537065 3.01750365,3.3040496 C3.57541509,7.58269186 5.53613261,10.5133418 9,12 C12.4638674,10.5133418 14.4245849,7.58269186 14.9824963,3.3040496 C15.0494783,2.72537065 14.9222646,2.13675232 14.6344144,1.69347201 C14.3465642,1.25019171 13.9269882,0.996771188 13.4863705,1",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51351418,23 C4.07308934,23.0031696 3.65369602,22.7499277 3.3658765,22.3069625 C3.07805698,21.8639972 2.95069125,21.275756 3.01734993,20.6972855 C3.5752757,16.4186424 5.5360436,13.4879918 9,12 C12.4639564,13.4879918 14.4247243,16.4186424 14.9826501,20.6972855 C15.0493088,21.275756 14.921943,21.8639972 14.6341235,22.3069625 C14.346304,22.7499277 13.9269107,23.0031696 13.4864858,23",
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 1,
    x2: 18,
    y2: 1,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 23,
    x2: 18,
    y2: 23,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "receipt",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,22 L18,1.46666667 C18,0.656649034 17.3284271,0 16.5,0 L1.5,0 C0.671572875,0 0,0.656649034 0,1.46666667 L0,22 L3,19.0666667 L6,22 L9,19.0666667 L12,22 L15,19.0666667 L18,22 Z",
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 6,
    x2: 13,
    y2: 6,
    id: "Shape",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 11,
    x2: 9,
    y2: 11,
    id: "Shape",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "messages",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5662439,5.6446148 C26.0716027,3.53679628 24.594159,1.63384427 22.5105638,0.940011625 C18.1306128,-0.313337208 8.86985967,-0.313337208 4.48963872,0.940011625 C2.40631352,1.63384427 0.928869822,3.53706763 0.433958585,5.6446148 C-0.144652862,8.5103037 -0.144652862,11.4717779 0.433958585,14.3371954 C0.928869822,16.4450139 2.40604352,18.3479659 4.48963872,19.0417986 C5.47136118,19.3226421 6.69959425,19.5399905 8.06201766,19.6952006 C8.08685772,20.4191527 7.78121695,21.5213616 6.37073343,22.9407744 C4.37758844,24.9462954 8.77076943,23.668254 10.4193935,22.6631871 C11.782357,21.8320532 13.1059003,21.0003766 14.3416934,19.9746874 C17.4634412,19.9274731 20.5009488,19.6170529 22.5105638,19.0417986 C24.594159,18.3479659 26.0713327,16.4450139 26.5662439,14.3371954 C27.1445854,11.4717779 27.1445854,8.5103037 26.5662439,5.6446148 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "help",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3.05176e-05C8.82441 3.05176e-05 6.69767 0.645169 4.88873 1.85386C3.07979 3.06256 1.66989 4.78053 0.83733 6.79051C0.00476615 8.8005 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3166 6.72022 21.3642 8.85401 21.7887C10.9878 22.2131 13.1995 21.9953 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3024 22 13.1756 22 11C21.9965 8.08372 20.8365 5.28786 18.7743 3.22571C16.7122 1.16357 13.9163 0.0035238 11 3.05176e-05ZM12.375 16.5C12.375 16.8647 12.2301 17.2144 11.9723 17.4723C11.7144 17.7302 11.3647 17.875 11 17.875C10.6353 17.875 10.2856 17.7302 10.0277 17.4723C9.76987 17.2144 9.625 16.8647 9.625 16.5V12.1C9.625 11.7354 9.76987 11.3856 10.0277 11.1278C10.2856 10.8699 10.6353 10.725 11 10.725C11.3647 10.725 11.7144 10.8699 11.9723 11.1278C12.2301 11.3856 12.375 11.7354 12.375 12.1V16.5ZM11 8.80003C10.5649 8.80003 10.1395 8.671 9.77775 8.42926C9.41596 8.18752 9.13398 7.84393 8.96747 7.44193C8.80096 7.03994 8.75739 6.59759 8.84228 6.17083C8.92716 5.74407 9.13669 5.35207 9.44437 5.0444C9.75204 4.73672 10.144 4.52719 10.5708 4.4423C10.9976 4.35742 11.4399 4.40098 11.8419 4.5675C12.2439 4.73401 12.5875 5.01599 12.8292 5.37778C13.071 5.73956 13.2 6.16491 13.2 6.60003C13.2 7.18351 12.9682 7.74309 12.5556 8.15567C12.1431 8.56825 11.5835 8.80003 11 8.80003Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "info",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "if_info2_216652",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21944,0 C5.02296,0 5.4246,0.54804 5.4246,1.17468 C5.4246,1.95732 4.72692,2.68128 3.81768,2.68128 C3.0564,2.68128 2.61228,2.23104 2.6334,1.48764 C2.6334,0.86112 3.162,0 4.21944,0 Z M1.74516,12 C1.11072,12 0.64548,11.60856 1.0896,9.8862 L1.818,6.83136 C1.94484,6.34212 1.9656,6.14652 1.818,6.14652 C1.62744,6.14652 0.80388,6.48444 0.3168,6.81732 L0,6.28872 C1.54356,4.9776 3.31944,4.20864 4.08048,4.20864 C4.71468,4.20864 4.82064,4.97196 4.50348,6.1464 L3.6696,9.3576 C3.52152,9.92508 3.58524,10.12068 3.73284,10.12068 C3.92316,10.12068 4.54728,9.88512 5.16036,9.39576 L5.52,9.88524 C4.01856,11.412 2.3796,12 1.74516,12 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "mfd",
    fill: "none",
    transform: "translate(0.000000, 1.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "1 30 1 1 12.25 1 16 4.86666667 31 4.86666667 31 30",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14,
    x2: 30.5,
    y2: 14,
    id: "Line",
    strokeLinecap: "square",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 22,
    x2: 30.5,
    y2: 22,
    id: "Line",
    strokeLinecap: "square",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 31,
    y2: 0,
    id: "Path-3",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    className: "duo",
    transform: "translate(14.000000, 17.500000)",
    strokeLinecap: "square",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 4,
    y2: 0.5,
    id: "Line",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8.5,
    x2: 4,
    y2: 8.5,
    id: "Line",
    fill: "none",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,15 L27,2 C27,0.8954305 26.1045695,0 25,0 L5,0 C3.8954305,0 3,0.8954305 3,2 L3,15 L27,15 Z",
    id: "Shape",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.828,21.188 C30.1028645,21.8066976 30.0460754,22.5224476 29.6770866,23.0900606 C29.3080978,23.6576735 28.677006,24 28,24 L2,24 C1.32299397,24 0.691902192,23.6576735 0.322913412,23.0900606 C-0.0460753694,22.5224476 -0.102864455,21.8066976 0.172,21.188 L3,15 L27,15 L29.828,21.188 Z",
    id: "Shape",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 11,
    y2: 17,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "remote-settings",
    transform: "translate(1.000000, 1.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,8 L19,1.38461538 C19,0.619913423 18.2955844,-3.90798505e-14 17.55,-3.90798505e-14 L1.35,-3.90798505e-14 C0.604415588,-3.90798505e-14 0,0.619913423 0,1.38461538 L0,16.6153846 C0,17.3800866 0.604415588,18 1.35,18 L9,18",
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4,
    x2: 18.9,
    y2: 4,
    id: "Shape",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0555443,13.7309913 C20.4445255,13.3281607 20.5153956,12.7281257 20.2302953,12.2514296 C19.945195,11.7747335 19.3707473,11.5327721 18.8138267,11.654803 L17.8963198,11.8599919 C17.8182785,11.8782481 17.7394026,11.8330635 17.7187981,11.7582974 L17.4431723,10.8880442 C17.2782096,10.3608214 16.7740667,10 16.202389,10 C15.6307113,10 15.1265684,10.3608214 14.9616057,10.8880442 L14.6859799,11.7582974 C14.6633346,11.8319887 14.5854816,11.8763538 14.5075239,11.8599919 L13.5900169,11.654803 C13.0332633,11.5333348 12.4593147,11.7755006 12.1745213,12.2520422 C11.8897278,12.7285838 11.9605694,13.3282611 12.3492337,13.7309913 L12.9901804,14.3969555 C13.0454211,14.4553488 13.0454211,14.5446512 12.9901804,14.6030445 L12.3492337,15.2690087 C11.9596584,15.6715743 11.8884697,16.2718961 12.1737645,16.7487106 C12.4590592,17.225525 13.0340183,17.4671572 13.5909513,17.3442971 L14.5075239,17.1400081 C14.5854369,17.1221352 14.6641313,17.166583 14.6859799,17.2408026 L14.9616057,18.1119558 C15.1265684,18.6391786 15.6307113,19 16.202389,19 C16.7740667,19 17.2782096,18.6391786 17.4431723,18.1119558 L17.7187981,17.2408026 C17.7393827,17.166086 17.8184832,17.1211738 17.8963198,17.1400081 L18.814761,17.3442971 C19.371527,17.466592 19.945985,17.2247548 20.2309721,16.7480958 C20.5159592,16.2714369 20.4448004,15.6714745 20.0555443,15.2690087 L19.4136632,14.6030445 C19.3592857,14.5443318 19.3592857,14.4556682 19.4136632,14.3969555 L20.0555443,13.7309913 Z M16,16 C15.1715729,16 14.5,15.3284271 14.5,14.5 C14.5,13.6715729 15.1715729,13 16,13 C16.8284271,13 17.5,13.6715729 17.5,14.5 C17.5,15.3284271 16.8284271,16 16,16 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "construction-sign",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.375,4.98048 C17.4509732,5.0225702 17.4984106,5.09980577 17.5,5.184 L17.5,5.76 C17.5,5.89254834 17.3880712,6 17.25,6 L17.116,6 C17.0699182,5.99986415 17.0255372,6.0167003 16.992,6.04704 L9.468,13.27008 C9.39631158,13.3387268 9.37483493,13.4421069 9.41360785,13.5319024 C9.45238076,13.6216978 9.54374556,13.6801739 9.645,13.6800008 L14.384,13.6800008 C14.4300818,13.6801359 14.4744628,13.6632997 14.508,13.63296 L22.032,6.40992 C22.1036884,6.34127319 22.1251651,6.23789307 22.0863922,6.14809762 C22.0476192,6.05830218 21.9562544,5.99982608 21.855,6 L19.75,6 C19.6119288,6 19.5,5.89254834 19.5,5.76 L19.5,5.184 C19.5001806,5.09842997 19.5478062,5.01942492 19.625,4.97664 C20.506928,4.48782587 20.9369048,3.49129238 20.6733331,2.54697599 C20.4097614,1.6026596 19.5183628,0.946025128 18.5,0.946025128 C17.4816372,0.946025128 16.5902386,1.6026596 16.3266669,2.54697599 C16.0630952,3.49129238 16.493072,4.48782587 17.375,4.97664 L17.375,4.98048 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.006,13.27008 C16.9343116,13.3387268 16.9128349,13.4421069 16.9516078,13.5319024 C16.9903808,13.6216978 17.0817456,13.6801739 17.183,13.68 L19.5,13.68 C19.6380712,13.68 19.75,13.7874517 19.75,13.92 L19.75,22.8 C19.75,23.4627417 20.3096441,24 21,24 C21.6903559,24 22.25,23.4627417 22.25,22.8 L22.25,13.92 C22.25,13.7874517 22.3619288,13.68 22.5,13.68 C23.3284271,13.68 24,13.03529 24,12.24 L24,7.44 C23.999897,7.32901483 23.9857944,7.21845001 23.958,7.11072 C23.9362583,7.02658685 23.8689478,6.96024671 23.7819111,6.93716955 C23.6948745,6.9140924 23.6016387,6.93786487 23.538,6.99936 L17.006,13.27008 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.119,6.40992 C7.19068842,6.34127319 7.21216507,6.23789307 7.17339215,6.14809762 C7.13461924,6.05830218 7.04325444,5.99982608 6.942,6 L6.75,6 C6.61192881,6 6.49999935,5.89254834 6.49999935,5.76 L6.49999935,5.184 C6.50018064,5.09842997 6.54780618,5.01942492 6.625,4.97664 C7.50692803,4.48782587 7.93690479,3.49129238 7.67333311,2.54697599 C7.40976143,1.6026596 6.51836278,0.946025128 5.49999935,0.946025128 C4.48163722,0.946025128 3.59023857,1.6026596 3.32666689,2.54697599 C3.06309521,3.49129238 3.49307197,4.48782587 4.375,4.97664 C4.45219382,5.01942492 4.49981936,5.09842997 4.49999935,5.184 L4.49999935,5.76 C4.49999935,5.89254834 4.38807119,6 4.25,6 L1.49999935,6 C0.671572875,6 -6.49878683e-07,6.64470996 -6.49878683e-07,7.44 L-6.49878683e-07,12.24 C-0.000147574855,12.3897423 0.0248393326,12.5385292 0.074,12.68064 C0.100379963,12.7603047 0.168192857,12.8209527 0.252834784,12.8405798 C0.33747671,12.8602069 0.426649709,12.8359614 0.488,12.77664 L7.119,6.40992 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.969,13.632 L6.969,13.632 L14.491,6.41088 C14.5626884,6.34223319 14.5841651,6.23885307 14.5453922,6.14905762 C14.5066192,6.05926218 14.4152544,6.00095918 14.314,6.00095918 L9.741,6.00095918 C9.69491824,6.00095918 9.65053722,6.0176603 9.617,6.048 L1.708,13.63968 C1.70272217,13.6475772 1.70272217,13.6577028 1.708,13.6656 C1.71198883,13.6743741 1.72102784,13.6800333 1.731,13.68 C1.74425483,13.68 1.755,13.6903154 1.755,13.70304 L1.755,22.8 C1.755,23.4627417 2.31464406,24 3.005,24 C3.69535594,24 4.255,23.4627417 4.255,22.8 L4.255,13.92 C4.255,13.7874517 4.36692881,13.68 4.505,13.68 L6.85,13.68 C6.89467538,13.6795384 6.93738835,13.6623096 6.969,13.632 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "megaphone",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04800651,14.7346246 C0.881318456,14.9423992 0.866560651,15.2399356 1.01180478,15.4644981 L2.18894474,17.311078 C2.33177047,17.5325345 2.59647006,17.6311852 2.84174358,17.5543692 L2.84174358,17.5543692 L5.47746271,16.7332615 C5.60028658,16.6941368 5.73320388,16.7435852 5.80444603,16.8549071 L6.50512458,17.9618819 C7.43133431,19.4391292 9.27006002,19.9643349 10.7900811,19.1858183 C12.3101023,18.4073017 13.0335816,16.5697991 12.4760736,14.903712 C12.4491736,14.8220557 12.4570014,14.7323227 12.4975904,14.6570545 C12.5381795,14.5817863 12.6076726,14.5281358 12.6886127,14.5095803 L17.7031355,13.3369169 C17.8198024,13.307552 17.941802,13.3558725 18.0102663,13.4585625 L18.1013545,13.6008878 C18.2642599,13.8555462 18.5386191,14.0084854 18.8323958,14.0084005 C19.0044609,14.0087709 19.1727467,13.9558429 19.315864,13.8563435 C19.7185186,13.5772237 19.8282342,13.0112301 19.5611015,12.5912295 L12.1117207,0.904738553 C11.8440637,0.484844808 11.3003093,0.370473387 10.8972113,0.649282833 C10.4941133,0.92809228 10.3843167,1.49450313 10.6519738,1.91439687 L10.7348874,2.04334119 C10.8080729,2.15537316 10.8009192,2.30440921 10.7173704,2.40827793 L1.04800651,14.7346246 Z M10.1988683,17.4193426 C9.4600657,17.9302448 8.46354916,17.7205676 7.97304613,16.9510071 L7.66007638,16.4644248 C7.60934222,16.3839579 7.59801105,16.2832797 7.62950224,16.1927712 C7.66099343,16.1022628 7.73161829,16.0325258 7.82006465,16.0046045 L10.4277566,15.1895791 C10.5687124,15.1465421 10.7184834,15.2188274 10.7780959,15.3586665 C11.089616,16.1010334 10.8455769,16.9692336 10.1988683,17.4193426 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "id",
    fill: "none",
    transform: "translate(1.500000, 1.500000)",
    stroke: "#8E959E",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "14.9333333 23 0 23 0 0 32 0 32 6.27272727",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 13,
    x2: 11,
    y2: 23,
    id: "Shape",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 0,
    x2: 27,
    y2: 6,
    id: "Shape",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,24 L21.0163401,30.7685747 C20.9372269,31.2178958 21.1506128,31.6680751 21.5432924,31.8802835 C21.935972,32.0924919 22.4169904,32.0175763 22.7311576,31.695281 L25.5,28.8428068 L28.2688424,31.695281 C28.5830096,32.0175763 29.064028,32.0924919 29.4567076,31.8802835 C29.8493872,31.6680751 30.0627731,31.2178958 29.9836599,30.7685747 L29.5,24",
    id: "Path",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 25.5,
    cy: 17.5,
    r: 6.5,
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 11,
    x2: 11,
    y2: 0,
    id: "Shape",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "event",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-434.000000, -471.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.000000, 445.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,11 L9,11 L9,16 L14,16 L14,11 Z M13,0 L13,2 L5,2 L5,0 L3,0 L3,2 L2,2 C0.89,2 0.01,2.9 0.01,4 L0,18 C0,19.1 0.89,20 2,20 L16,20 C17.1,20 18,19.1 18,18 L18,4 C18,2.9 17.1,2 16,2 L15,2 L15,0 L13,0 Z M16,18 L2,18 L2,7 L16,7 L16,18 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "cal",
    transform: "translate(1.000000, 2.000000)",
    stroke: "currentColor",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,5.5 L47,5.5 C47.8284271,5.5 48.5,6.17157288 48.5,7 L48.5,46 C48.5,46.8284271 47.8284271,47.5 47,47.5 L2,47.5 C1.17157288,47.5 0.5,46.8284271 0.5,46 L0.5,7 C0.5,6.17157288 1.17157288,5.5 2,5.5 Z",
    id: "Rectangle-path",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 18.4615385,
    x2: 48,
    y2: 18.4615385,
    id: "Shape",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.423077,
    y1: 11.0769231,
    x2: 13.5,
    y2: -1.04805054e-13,
    id: "Shape",
    strokeLinecap: "round",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.576923,
    y1: 11.0769231,
    x2: 35.5,
    y2: -1.04805054e-13,
    id: "Shape",
    strokeLinecap: "round",
    strokeWidth: 3,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,15 L6,15 L6,18 L22,18 L22,15 Z M26,3 L24,3 L24,0 L21,0 L21,3 L8,3 L8,0 L5,0 L5,3 L3,3 C1.43388889,3.2 0.0161111111,4.64 0,6 L0,29 C0,30.56 1.43388889,32 3,32 L26,32 C27.55,32 29,30.56 29,29 L29,6 C29,4.64 27.55,3.2 26,3 Z M26,29 L3,29 L3,11 L26,11 L26,29 Z M17,22 L6,22 L6,25 L17,25 L17,22 Z",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar-stroke",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 2,
    width: 22,
    height: 20,
    rx: 1.5,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 21,
    y2: 8,
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 0,
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 5,
    x2: 17,
    y2: 0,
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "calendar-warn",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0,
    y: 2,
    width: 22,
    height: 20,
    rx: 1.5,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 21,
    y2: 8,
    id: "Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 0,
    id: "Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 5,
    x2: 17,
    y2: 0,
    id: "Shape",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11 L16,19 L7,19 L11.5,11 Z M12,17 L11,17 L11,18 L12,18 L12,17 Z M12,14 L11,14 L11,16 L12,16 L12,14 Z",
    stroke: "none",
    id: "warn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "disconnect",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9146376,1.9430393 C6.06256037,1.59126346 6.28444454,1.06359969 6.58029009,0.360048006 C6.67205592,0.141465609 6.87962534,0 7.10903996,0 L13.0353487,0 C13.2572898,0 13.4595306,0.132439283 13.5555554,0.340449994 C13.6515802,0.548460705 13.6243814,0.795283038 13.4855942,0.975330044 L10.3685097,5.02627017 C10.2301122,5.20644131 10.2032538,5.45311256 10.299411,5.66088398 C10.3955682,5.86865541 10.5977339,6.00077912 10.8195249,6.00080011 L13.4224828,6.00080011 C13.6561343,6.00068975 13.8668056,6.14701831 13.9561327,6.37146388 C14.0454599,6.59590944 13.9958229,6.85419962 13.8303976,7.02573676 C13.265623,7.61268915 12.8420421,8.05290344 12.5596548,8.34637963 M7.85418903,12.197353 C6.79795722,13.2950614 4.93682521,15.229277 2.27079303,18 L5.38941677,10.4357914 C5.46560145,10.2503763 5.44725646,10.037599 5.34056902,9.86922302 C5.23388159,9.70084705 5.05307409,9.59931846 4.85912759,9.59887985 L2.57865322,9.59887985 C2.38405192,9.59964596 2.202214,9.49829321 2.09512891,9.32937326 C1.98804382,9.16045332 1.97016762,8.94676967 2.04759439,8.76116816 C2.40152465,7.91948495 2.65967487,7.3055767 2.82204505,6.91944341",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.84147705e-14,
    y1: 0,
    x2: 15,
    y2: 15,
    id: "Shape",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "remote-warning",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warn",
    transform: "translate(9.000000, 9.000000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 L11,10 L0,10 L5.5,0 Z M6,8 L5,8 L5,9 L6,9 L6,8 Z M6,4 L5,4 L5,7 L6,7 L6,4 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,10 L19,1.38461538 C19,0.619913423 18.2955844,-3.90798505e-14 17.55,-3.90798505e-14 L1.35,-3.90798505e-14 C0.604415588,-3.90798505e-14 0,0.619913423 0,1.38461538 L0,16.6153846 C0,17.3800866 0.604415588,18 1.35,18 L6,18",
    id: "Shape",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4,
    x2: 18.9,
    y2: 4,
    id: "Shape",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "remote-manage",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "cursor",
    transform: "translate(10.800000, 9.900000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 3.11547498 8.1 4.98452502 4.98524804 8.1 3.11592689",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1,
    y1: 8.1,
    x2: 5.4,
    y2: 5.4,
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,8 L19,1.38461538 C19,0.619913423 18.2955844,-3.90798505e-14 17.55,-3.90798505e-14 L1.35,-3.90798505e-14 C0.604415588,-3.90798505e-14 0,0.619913423 0,1.38461538 L0,16.6153846 C0,17.3800866 0.604415588,18 1.35,18 L9,18",
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4,
    x2: 18.9,
    y2: 4,
    id: "Shape",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pocket-health",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5941622,0 C35.0725734,0 45.1883244,10.115751 45.1883244,22.5941622 C45.1883244,35.0725734 35.0725734,45.1883244 22.5941622,45.1883244 C10.115751,45.1883244 0,35.0725734 0,22.5941622 C0,10.115751 10.115751,0 22.5941622,0 Z M33.1265712,12 C32.0919266,12 31.2531424,12.7892528 31.2531424,13.7628002 L31.2531424,13.7628002 L31.2531424,27.3388286 L22.651,32.011 L14.5356584,27.3390113 L14.5356584,13.7628213 C14.5356584,12.7892623 13.744154,12 12.7678292,12 C11.7915045,12 11,12.7892623 11,13.7628213 L11,13.7628213 L11,28.3568041 C11,28.9865881 11.3369349,29.5685524 11.8839146,29.8834922 L11.8839146,29.8834922 L20.5562644,34.8764815 C20.5904025,34.9586942 20.6315461,35.0395294 20.6798871,35.118313 C21.0268861,35.6838207 21.6565461,36 22.3040438,36 C22.4194657,36 22.5354572,35.9899474 22.6504192,35.9687586 C22.7599089,35.9895862 22.870928,36 22.9819536,36 C23.2871899,36 23.5923783,35.921289 23.8658682,35.7638661 L23.8658682,35.7638661 L28.9729304,32.823631 C29.1817805,32.703391 29.356719,32.5470744 29.4943999,32.3671331 L29.4943999,32.3671331 L34.0632856,29.8832785 C34.6429386,29.5683424 35,28.986385 35,28.3566086 L35,28.3566086 L35,13.7628002 C35,12.7892528 34.1612158,12 33.1265712,12 Z M27.3646433,12.7142857 L18.6353605,12.7142857 L18.4917959,12.7206885 C17.8752151,12.7758562 17.3365645,13.1833188 17.1102579,13.7794022 C16.8664988,14.4213841 17.0351561,15.1499814 17.534696,15.6133055 L17.534696,15.6133055 L21.9031967,19.6649162 L22.0238897,19.7666314 C22.3137619,19.9881445 22.6587946,20.0989011 23.0038612,20.0989011 C23.3986667,20.0989011 23.7935166,19.9538778 24.1055904,19.6639217 L24.1055904,19.6639217 L28.4663724,15.612311 L28.5756072,15.5007873 C28.9887562,15.0371719 29.1146519,14.3709889 28.8894797,13.7787241 C28.6455875,13.1371497 28.039805,12.7142857 27.3646433,12.7142857 L27.3646433,12.7142857 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mesh",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2,0 C24.267,0 21.867,2.4 21.867,5.333 C21.867,7.363 23.02,9.149 24.7,10.05 L21.783,19.233 C21.635,19.224 21.484,19.2 21.333,19.2 C19.088,19.2 17.088,20.222 15.717,21.8 L8.9,15.817 C9.343,15.091 9.6,14.241 9.6,13.333 C9.6,10.695 7.438,8.534 4.8,8.534 C2.161,8.534 0,10.695 0,13.333 C0,15.972 2.161,18.134 4.8,18.134 C5.755,18.134 6.65,17.853 7.4,17.367 L14.533,23.6 C14.107,24.538 13.867,25.573 13.867,26.667 C13.867,28.333 14.438,29.873 15.367,31.117 L9.167,37.317 C8.222,36.667 7.093,36.267 5.867,36.267 C2.639,36.267 0,38.906 0,42.133 C0,45.361 2.639,48 5.867,48 C9.094,48 11.733,45.361 11.733,42.133 C11.733,40.898 11.342,39.764 10.683,38.817 L16.867,32.633 C18.115,33.573 19.657,34.133 21.333,34.133 C22.853,34.133 24.268,33.686 25.45,32.9 L28.35,36.167 C27.628,37.077 27.2,38.222 27.2,39.466 C27.2,42.4 29.6,44.8 32.533,44.8 C35.466,44.8 37.867,42.4 37.867,39.466 C37.867,36.534 35.466,34.133 32.533,34.133 C31.617,34.133 30.755,34.372 30,34.784 L27.033,31.467 C28.127,30.167 28.8,28.491 28.8,26.667 C28.8,25.986 28.705,25.328 28.533,24.7 L40.233,21.1 C41.006,22.208 42.289,22.934 43.733,22.934 C46.076,22.934 47.999,21.011 47.999,18.667 C47.999,16.323 46.076,14.4 43.733,14.4 C41.389,14.4 39.467,16.323 39.467,18.667 C39.467,18.813 39.467,18.958 39.483,19.1 L27.666,22.733 C26.789,21.328 25.46,20.244 23.883,19.667 L26.75,10.65 C26.897,10.663 27.05,10.667 27.2,10.667 C30.133,10.667 32.533,8.267 32.533,5.333 C32.533,2.4 30.133,0 27.2,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "scanner",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.334,19.9999961 C0.260550256,19.9995872 0.19066544,20.0316244 0.143039132,20.087542 C0.0954128233,20.1434595 0.0749045146,20.2175518 0.087,20.29 C0.458,22.593 2.448,23.9999961 5.5,23.9999961 L18.5,23.9999961 C21.552,23.9999961 23.542,22.592 23.913,20.29 C23.9250955,20.2175518 23.9045872,20.1434595 23.8569609,20.087542 C23.8093346,20.0316244 23.7394497,19.9995872 23.666,19.9999961 L0.334,19.9999961 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.031,9.751 C3.92885491,9.75102377 3.83699797,9.81318558 3.799,9.908 L0.3,18.658 C0.269624643,18.7347453 0.279086408,18.8215373 0.325284748,18.8899349 C0.371483089,18.9583324 0.448463463,18.9995197 0.531,19 L23.469,19 C23.5519747,19 23.6295335,18.9587945 23.6760209,18.8900652 C23.7225084,18.8213359 23.7318666,18.7340198 23.701,18.657 L20.201,9.907 C20.163002,9.81218558 20.0711451,9.75 19.969,9.75 L4.031,9.751 Z M19.914,17.281 C19.8210629,17.4184959 19.6659591,17.5009182 19.5,17.501 L4.5,17.501 C4.3340506,17.501 4.17893309,17.4185889 4.08595817,17.2811303 C3.99298326,17.1436717 3.97426682,16.9690397 4.036,16.815 L6.036,11.815 C6.11167868,11.6249783 6.29546285,11.5002111 6.5,11.5 L17.5,11.5 C17.7042902,11.5 17.8880041,11.6243712 17.964,11.814 L19.964,16.814 C20.0260315,16.9682954 20.0072907,17.1433344 19.914,17.281 L19.914,17.281 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.09,8.251 C20.2083035,8.25016789 20.3099646,8.16683911 20.334,8.051 L21.988,0.609 C22.0210838,0.460889518 21.9851087,0.305769162 21.8902099,0.187340041 C21.795311,0.068910919 21.6517605,0 21.5,0 L2.5,0 C2.34845803,0 2.20512037,0.0688445993 2.11026333,0.187027143 C2.01540628,0.305209687 1.97926692,0.460035418 2.012,0.608 L3.666,8.055 C3.69003542,8.17083911 3.79169654,8.25416789 3.91,8.255 L20.09,8.251 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.082,1.5 C9.23575369,0.548136582 8.02364465,0.00246924721 6.75,0 L5.25,0 C2.76471863,0 0.75,2.01471863 0.75,4.5 C0.75,6.98528137 2.76471863,9 5.25,9 L6.75,9 C8.02353465,8.99702108 9.23544506,8.45144317 10.082,7.5",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.918,1.5 C14.764169,0.54803139 15.9763278,0.00234165914 17.25,0 L18.75,0 C21.2352814,0 23.25,2.01471863 23.25,4.5 C23.25,6.98528137 21.2352814,9 18.75,9 L17.25,9 C15.9764104,8.99727578 14.7644007,8.45165319 13.918,7.5",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75,4.499 L17.25,4.499",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "charge",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5,12.134 L47.5,7 C47.5,6.17157288 46.8284271,5.5 46,5.5 L40,5.5 C39.1715729,5.5 38.5,6.17157288 38.5,7 L38.5,12.134 C38.1906068,12.3126283 38,12.6427435 38,13 L38,21 C38,22.6568542 39.3431458,24 41,24 L41,28 C41.0030859,32.0862856 39.4365498,36.0176613 36.624,38.982 C37.8690787,34.1259654 35.9642926,29.0076594 31.8474591,26.1470694 C27.7306257,23.2864794 22.2693743,23.2864794 18.1525409,26.1470694 C14.0357074,29.0076594 12.1309213,34.1259654 13.376,38.982 C10.5634502,36.0176613 8.99691407,32.0862856 9,28 L9,24 C10.3260824,24 11.597852,23.4732158 12.5355339,22.5355339 C13.4732158,21.597852 14,20.3260824 14,19 L14,10 C14,9.44771525 13.5522847,9 13,9 L12.5,9 L12.5,2 C12.5,1.17157288 11.8284271,0.5 11,0.5 L3,0.5 C2.17157288,0.5 1.5,1.17157288 1.5,2 L1.5,9 L1,9 C0.44771525,9 0,9.44771525 0,10 L0,19 C0,21.7614237 2.23857625,24 5,24 L5,28 C5,39.045695 13.954305,48 25,48 C36.045695,48 45,39.045695 45,28 L45,24 C46.6568542,24 48,22.6568542 48,21 L48,13 C48,12.6427435 47.8093932,12.3126283 47.5,12.134 Z M4.5,4 C4.5,3.72385763 4.72385763,3.5 5,3.5 L9,3.5 C9.27614237,3.5 9.5,3.72385763 9.5,4 L9.5,8.5 C9.5,8.77614237 9.27614237,9 9,9 L5,9 C4.72385763,9 4.5,8.77614237 4.5,8.5 L4.5,4 Z M25,28 C29.418278,28 33,31.581722 33,36 C33,40.418278 29.418278,44 25,44 C20.581722,44 17,40.418278 17,36 C17,31.581722 20.581722,28 25,28 Z M44,8.5 C44.2761424,8.5 44.5,8.72385763 44.5,9 L44.5,11.5 C44.5,11.7761424 44.2761424,12 44,12 L42,12 C41.7238576,12 41.5,11.7761424 41.5,11.5 L41.5,9 C41.5,8.72385763 41.7238576,8.5 42,8.5 L44,8.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,12 L21.5,12 C21.7761424,12 22,12.2238576 22,12.5 L22,19 C21.9997886,19.4182498 22.259893,19.7924491 22.652,19.938 C23.0443751,20.0797538 23.4835281,19.9661934 23.758,19.652 L31.64,10.474 C32.019949,10.0290011 32.1064494,9.40368212 31.8615699,8.87225074 C31.6166904,8.34081935 31.0851369,8.0002948 30.5,8 L28.5,8 C28.2238576,8 28,7.77614237 28,7.5 L28,1 C27.9998936,0.581923485 27.7397174,0.208038504 27.3477312,0.0626602478 C26.9557451,-0.0827180081 26.5146923,0.0310979777 26.242,0.348 L18.36,9.526 C17.980051,9.9709989 17.8935506,10.5963179 18.1384301,11.1277493 C18.3833096,11.6591807 18.9148631,11.9997052 19.5,12 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "co2",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6902,51.3296 L30.6902,51.1606 C30.6902,51.1036 30.6902,51.0476 30.6352,51.0476 C30.6352,50.9916 30.6352,50.9346 30.5812,50.9346 C30.5812,50.8776 30.5252,50.8216 30.5252,50.7656 C30.5252,50.7656 30.5252,50.7086 30.4712,50.7086 C27.5112,45.9106 27.0732,39.8146 27.0732,34.5086 C27.0732,33.7186 26.4702,33.0976 25.7032,33.0976 L18.0302,33.0976 C17.9762,32.0816 17.9762,31.0656 17.9762,30.1056 C17.9762,29.3156 17.3732,28.6946 16.6062,28.6946 L5.9732,28.6946 C5.2062,28.6946 4.6032,29.3156 4.6032,30.1056 C4.6032,31.9686 4.5482,33.5496 4.4942,35.0166 C4.1102,41.6776 2.7402,46.8136 0.2742,50.7086 C0.2742,50.7086 0.2742,50.7656 0.2192,50.7656 C0.1642,50.8216 0.1642,50.8776 0.1092,50.9346 C0.1092,50.9916 0.1092,50.9916 0.0552,51.0476 C0.0552,51.1036 0.0002,51.1606 0.0002,51.2166 L0.0002,51.3866 L0.0002,51.4986 L0.0002,51.6686 L0.0002,51.7816 C0.0002,51.8376 0.0002,51.8376 0.0552,51.8936 C0.0552,51.9506 0.1092,52.0066 0.1092,52.0636 C0.1092,52.1206 0.1642,52.1206 0.1642,52.1766 C0.1642,52.2326 0.2192,52.2886 0.2192,52.3456 C0.2192,52.4026 0.2742,52.4026 0.2742,52.4586 C0.3292,52.5156 0.3292,52.5156 0.3832,52.5716 L0.4382,52.6276 C0.4932,52.6846 0.5482,52.6846 0.5482,52.7406 L0.6032,52.7406 C0.7122,52.7976 0.7672,52.8536 0.8772,52.8536 C0.9312,52.8536 0.9312,52.8536 0.9862,52.9106 C1.0962,52.9106 1.2062,52.9666 1.3152,52.9666 L13.5362,52.9666 L21.0442,52.9666 L29.2112,52.9666 C29.3202,52.9666 29.4302,52.9666 29.5392,52.9106 L29.6482,52.9106 C29.7582,52.8536 29.8682,52.8536 29.9232,52.7976 L29.9782,52.7976 C30.0322,52.7406 30.0872,52.7406 30.0872,52.6846 L30.1422,52.6276 C30.1972,52.5716 30.1972,52.5716 30.2522,52.5156 C30.3062,52.4586 30.3062,52.4586 30.3612,52.4026 C30.3612,52.3456 30.4162,52.3456 30.4162,52.2886 C30.4162,52.2326 30.4712,52.2326 30.4712,52.1766 C30.4712,52.1206 30.4712,52.1206 30.5252,52.0636 C30.5252,52.0066 30.5812,51.9506 30.5812,51.8936 L30.5812,51.7816 L30.5812,51.6116 C30.6902,51.3866 30.6902,51.3866 30.6902,51.3296",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5701,3.7671 C38.8211,3.0271 36.8701,2.9601 35.0541,3.4981 C33.2381,1.3451 30.4801,0.0001 27.4531,0.0001 C23.0811,0.0001 19.3141,2.7581 17.9681,6.7941 C14.6731,6.8611 11.7801,8.9461 10.5691,11.9061 C7.3411,11.9061 4.7841,14.5291 4.7841,17.7581 C4.7841,20.9871 7.4071,23.6101 10.6361,23.6101 C11.9821,23.6101 13.3271,23.1401 14.3361,22.2651 C15.5471,22.8711 16.8251,23.2071 18.2371,23.2071 C19.6501,23.2071 20.9951,22.8711 22.2061,22.1981 C23.6861,23.4091 25.5701,24.1481 27.6551,24.1481 C31.0851,24.1481 34.0451,22.1981 35.4581,19.2381 C36.1301,19.3721 36.8031,19.5071 37.4761,19.5071 C41.9831,19.5071 45.6821,15.8081 45.6821,11.3011 C45.5481,8.0051 43.5971,5.0451 40.5701,3.7671",
    id: "Fill-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "deforest",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.762,18.067 C3.53659313,18.0136049 3.30402502,18.1220264 3.2,18.329 L2.72,19.29 L2.411,19.29 C2.13485763,19.29 1.911,19.5138576 1.911,19.79 L1.911,23.5 C1.911,23.7761424 2.13485763,24 2.411,24 L3.648,24 C3.92414237,24 4.148,23.7761424 4.148,23.5 L4.148,18.553 C4.14761468,18.3210853 3.98780674,18.1198763 3.762,18.067 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.976,0.184 C21.8650531,0.0478647949 21.6908184,-0.0200829486 21.517,0.005 L15.461,0.889 C14.8672657,0.975365666 14.4478148,1.51535344 14.511,2.112 C14.5391456,2.38362651 14.344151,2.62759229 14.073,2.66 L8.68,3.3 C8.27402572,3.34785087 7.92653389,3.6134577 7.77381751,3.99264436 C7.62110112,4.37183102 7.68751103,4.80413564 7.947,5.12 C8.06982775,5.27152934 8.09851956,5.47866476 8.02150503,5.6578757 C7.94449049,5.83708663 7.77446733,5.9588258 7.58,5.974 L3.2,6.3 C2.78413167,6.33145271 2.42026273,6.59156822 2.25592558,6.97488147 C2.09158843,7.35819472 2.1540558,7.80109258 2.418,8.124 L5.336,11.7 C5.5082826,11.9133274 5.47660821,12.2256101 5.265,12.4 L2.209,14.9 C2.02905784,15.0467558 1.97382865,15.2980792 2.07566313,15.5067564 C2.17749762,15.7154336 2.40959364,15.8265423 2.636,15.775 L3.683,15.539 L3.883,15.778 C3.96672397,15.8809916 4.08796269,15.9464677 4.22,15.96 L4.27,15.96 C4.38520606,15.9598633 4.49683053,15.919947 4.586,15.847 L6.686,14.131 C6.8993274,13.9587174 7.2116101,13.9903918 7.386,14.202 L10.307,17.775 C10.5711733,18.097818 10.9929753,18.2469007 11.4013305,18.1617829 C11.8096856,18.0766652 12.1367993,17.771478 12.25,17.37 L13.44,13.14 C13.4930107,12.9524579 13.6459023,12.8099471 13.836703,12.770232 C14.0275037,12.7305169 14.2245605,12.8001859 14.348,12.951 C14.6064081,13.2672292 15.016567,13.4175728 15.4181297,13.3432556 C15.8196924,13.2689384 16.1488799,12.981764 16.277,12.594 L17.977,7.437 C18.0627946,7.17738674 18.3412152,7.03483539 18.602,7.117 C19.174304,7.29659043 19.7863528,6.99255177 19.989,6.428 L22.06,0.669 C22.1190252,0.50379211 22.0871472,0.319734722 21.976,0.184 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "contact",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.83333333 L0,30.6666667 C0,32.775 1.70583333,34.5 3.83333333,34.5 L30.6666667,34.5 C32.775,34.5 34.5,32.775 34.5,30.6666667 L34.5,3.83333333 C34.5,1.725 32.775,0 30.6666667,0 L3.83333333,0 C1.70583333,0 0,1.725 0,3.83333333 L0,3.83333333 Z M23,11.5 C23,14.6816667 20.4316667,17.25 17.25,17.25 C14.0683333,17.25 11.5,14.6816667 11.5,11.5 C11.5,8.31833333 14.0683333,5.75 17.25,5.75 C20.4316667,5.75 23,8.31833333 23,11.5 L23,11.5 Z M5.75,26.8333333 C5.75,23 13.4166667,20.8916667 17.25,20.8916667 C21.0833333,20.8916667 28.75,23 28.75,26.8333333 L28.75,28.75 L5.75,28.75 L5.75,26.8333333 L5.75,26.8333333 Z",
    id: "Shape",
    fill: "#5A6B7D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-print"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1799516,26.6016498 L63.1799516,27.8360187 C63.131302,28.0322234 63.0642941,28.2261334 63.0367565,28.4255509 C62.5998281,31.5921351 60.9478069,33.9250211 58.160093,35.4439443 C57.7220171,35.6826027 57.1689721,35.817307 56.6687074,35.8179954 C41.4062719,35.8372717 26.1433775,35.8384191 10.8809421,35.8212081 C9.99882386,35.8202902 9.0937577,35.7358419 8.23871801,35.5274747 C2.73787091,34.1882338 -0.660716779,29.1401493 0.108038708,23.5204319 C0.771233741,18.6724533 4.79928301,14.8208735 9.64703217,14.4089583 C10.296229,14.3536538 10.9490974,14.3385082 11.5808538,14.3056926 C11.6866437,7.7623213 14.4938634,2.91663746 20.7024245,0.848799936 C27.7609768,-1.5019855 33.2492025,1.14941775 37.1955572,7.32608125 C39.8065721,5.686452 42.6413292,5.13639024 45.6608172,5.66006189 C50.8160686,6.55388357 55.2773747,11.0122064 55.2971099,17.2955778 C55.2989457,17.9078284 55.4359448,18.1012794 56.0064302,18.249982 C59.6957681,19.2117295 61.9944618,21.5682519 62.9018227,25.2738829 C63.0094485,25.7128767 63.0879304,26.1587549 63.1799516,26.6016498 Z",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-9",
    transform: "translate(13.437500, 53.454665)",
    fill: "#3E4750"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0897249779,24.5306427 L12.2219961,24.5306427 L12.2219961,24.8064595 C12.2219961,25.911029 13.1174266,26.8064595 14.2219961,26.8064595 L24.1384247,26.8064595 C25.2429942,26.8064595 26.1384247,25.911029 26.1384247,24.8064595 L26.1384247,24.5306427 L36.8433697,24.5306427 L36.8433697,31.6100995 L0.0897249779,31.6100995 L0.0897249779,24.5306427 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8433697,23.4905351 L0.0897249779,23.4905351 L0.0897249779,2.89122115 C0.0897249779,1.78665165 0.985155478,0.891221146 2.08972498,0.891221146 L16.4665474,0.891221146 C17.5711169,0.891221146 18.4665474,1.78665165 18.4665474,2.89122115 L18.4665474,7.75172717 L34.8433697,7.75172717 C35.9479392,7.75172717 36.8433697,8.64715767 36.8433697,9.75172717 L36.8433697,23.4905351 Z",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 23.3687681,
    y: 0.891221146,
    width: 7.16666667,
    height: 2.69211219
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    points: "23.8635694 46.8151989 32.8219028 38.7526989 40.8844028 46.8151989 38.5754851 46.8151989 38.5754851 61.1485322 26.5510694 61.1485322 26.5510694 46.8151989"
  })), /*#__PURE__*/React.createElement("g", {
    id: "byod"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38917644,0 L54.8177479,0 C55.9223174,-2.02906125e-16 56.8177479,0.8954305 56.8177479,2 L56.8177479,35.4648976 L5.38917644,35.4648976 L5.38917644,2 C5.38917644,0.8954305 6.28460694,2.02906125e-16 7.38917644,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,38.893469 L61.1034622,38.893469 L61.1034622,41.7425216 L2,41.7425216 C0.8954305,41.7425216 1.3527075e-16,40.8470911 0,39.7425216 L0,38.893469 Z",
    id: "Rectangle-Copy-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E4750",
    x: 8.81774787,
    y: 2.89346904,
    width: 44.5714286,
    height: 29.4429833
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(49.960605, 8.958134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 5.68434189e-14,
    y: 0,
    width: 22.7783529,
    height: 37.7142857,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3E4750",
    x: 1.71428571,
    y: 5.3877551,
    width: 18.8571429,
    height: 26.9387755
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    fill: "#EAEAEA",
    points: "0.246319294 38.893469 5.38917644 35.4648976 49.960605 35.4648976 49.960605 38.893469"
  })), /*#__PURE__*/React.createElement("g", {
    id: "findme"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.929564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.158699551,41.8957389 L21.6174507,41.8957389 L21.6174507,43.9210518 C21.6174507,45.0256213 22.5128812,45.9210518 23.6174507,45.9210518 L44.2319006,45.9210518 C45.3364701,45.9210518 46.2319006,45.0256213 46.2319006,43.9210518 L46.2319006,41.8957389 L65.1660928,41.8957389 L65.1660928,54.4174095 L0.158699551,54.4174095 L0.158699551,41.8957389 Z",
    id: "Path-2",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1660928,40.0560661 L0.158699551,40.0560661 L0.158699551,2.08390823 C0.158699551,0.979338725 1.05413005,0.0839082251 2.15869955,0.0839082251 L30.6623962,0.0839082251 C31.7669657,0.0839082251 32.6623962,0.979338725 32.6623962,2.08390823 L32.6623962,12.2183133 L63.1660928,12.2183133 C64.2706623,12.2183133 65.1660928,13.1137438 65.1660928,14.2183133 L65.1660928,40.0560661 Z",
    id: "Path-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 21.7333822,
    y: 0.0839082251,
    width: 32.2756564,
    height: 4.76162832
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#EAEAEA",
    x: 8.22005138,
    y: 5.15143483e-14,
    width: 29.8484848,
    height: 17.9090909,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3E4750",
    points: "10.9438735 2.56398073 35.2446922 2.56398073 35.2446922 15.3451102 10.9438735 15.3451102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tick",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83492951,17.745614 C3.95553267,17.745614 -2.48689958e-14,13.773123 -2.48689958e-14,8.87280702 C-2.48689958e-14,3.97249101 3.95553267,2.48689958e-14 8.83492951,2.48689958e-14 C13.7143263,2.48689958e-14 17.669859,3.97249101 17.669859,8.87280702 C17.669859,13.773123 13.7143263,17.745614 8.83492951,17.745614 Z M7.36152219,9.86747163 L4.87902589,7.38029671 L3.34218236,8.92372906 L7.33462012,12.9332834 L14.3382405,6.30446499 L12.8386444,4.79843978 L12.1047018,5.55011401 L7.36152219,9.86747163 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "error",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83492951,17.745614 C3.95553267,17.745614 -1.77635684e-14,13.773123 -1.77635684e-14,8.87280702 C-1.77635684e-14,3.97249101 3.95553267,-5.32907052e-15 8.83492951,-5.32907052e-15 C13.7143263,-5.32907052e-15 17.669859,3.97249101 17.669859,8.87280702 C17.669859,13.773123 13.7143263,17.745614 8.83492951,17.745614 Z M11.5064007,13.1720562 L13.2992746,11.3714959 L10.6233435,8.68409238 L13.2992746,5.9966889 L11.5153205,4.20508657 L8.83938939,6.89249006 L6.16345828,4.20508657 L4.37058444,6.00564691 L7.04651555,8.69305039 L4.37058444,11.3804539 L6.15453851,13.1720562 L8.83046962,10.4846527 L11.5064007,13.1720562 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "people",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7096774,5.48387097 C15.2268817,5.48387097 16.4424731,4.25913978 16.4424731,2.74193548 C16.4424731,1.22473118 15.2268817,0 13.7096774,0 C12.1924731,0 10.9677419,1.22473118 10.9677419,2.74193548 C10.9677419,4.25913978 12.1924731,5.48387097 13.7096774,5.48387097 L13.7096774,5.48387097 Z M6.39784946,5.48387097 C7.91505376,5.48387097 9.13064516,4.25913978 9.13064516,2.74193548 C9.13064516,1.22473118 7.91505376,0 6.39784946,0 C4.88064516,0 3.65591398,1.22473118 3.65591398,2.74193548 C3.65591398,4.25913978 4.88064516,5.48387097 6.39784946,5.48387097 L6.39784946,5.48387097 Z M6.39784946,7.31182796 C4.26827957,7.31182796 0,8.3811828 0,10.5107527 L0,12.7956989 L12.7956989,12.7956989 L12.7956989,10.5107527 C12.7956989,8.3811828 8.52741935,7.31182796 6.39784946,7.31182796 L6.39784946,7.31182796 Z M13.7096774,7.31182796 C13.4446237,7.31182796 13.1430108,7.33010753 12.8231183,7.35752688 C13.8833333,8.12526882 14.6236559,9.15806452 14.6236559,10.5107527 L14.6236559,12.7956989 L20.1075269,12.7956989 L20.1075269,10.5107527 C20.1075269,8.3811828 15.8392473,7.31182796 13.7096774,7.31182796 L13.7096774,7.31182796 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "globe",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13978495,0 C4.09462366,0 0,4.09462366 0,9.13978495 C0,14.1849462 4.09462366,18.2795699 9.13978495,18.2795699 C14.1849462,18.2795699 18.2795699,14.1849462 18.2795699,9.13978495 C18.2795699,4.09462366 14.1849462,0 9.13978495,0 L9.13978495,0 Z M8.22580645,16.3876344 C4.6155914,15.9397849 1.82795699,12.8688172 1.82795699,9.13978495 C1.82795699,8.57311828 1.90107527,8.03387097 2.01989247,7.50376344 L6.39784946,11.8817204 L6.39784946,12.7956989 C6.39784946,13.8010753 7.22043011,14.6236559 8.22580645,14.6236559 L8.22580645,16.3876344 L8.22580645,16.3876344 Z M14.5322581,14.066129 C14.2946237,13.3258065 13.6182796,12.7956989 12.7956989,12.7956989 L11.8817204,12.7956989 L11.8817204,10.0537634 C11.8817204,9.55107527 11.4704301,9.13978495 10.9677419,9.13978495 L5.48387097,9.13978495 L5.48387097,7.31182796 L7.31182796,7.31182796 C7.81451613,7.31182796 8.22580645,6.90053763 8.22580645,6.39784946 L8.22580645,4.56989247 L10.0537634,4.56989247 C11.0591398,4.56989247 11.8817204,3.74731183 11.8817204,2.74193548 L11.8817204,2.3672043 C14.5596774,3.45483871 16.4516129,6.07795699 16.4516129,9.13978495 C16.4516129,11.0408602 15.7204301,12.7682796 14.5322581,14.066129 L14.5322581,14.066129 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5483871,6.77419355 L12.5806452,6.77419355 L12.5806452,4.83870968 C12.5806452,2.16774194 10.4129032,0 7.74193548,0 C5.07096774,0 2.90322581,2.16774194 2.90322581,4.83870968 L2.90322581,6.77419355 L1.93548387,6.77419355 C0.870967742,6.77419355 0,7.64516129 0,8.70967742 L0,18.3870968 C0,19.4516129 0.870967742,20.3225806 1.93548387,20.3225806 L13.5483871,20.3225806 C14.6129032,20.3225806 15.483871,19.4516129 15.483871,18.3870968 L15.483871,8.70967742 C15.483871,7.64516129 14.6129032,6.77419355 13.5483871,6.77419355 L13.5483871,6.77419355 Z M7.74193548,15.483871 C6.67741935,15.483871 5.80645161,14.6129032 5.80645161,13.5483871 C5.80645161,12.483871 6.67741935,11.6129032 7.74193548,11.6129032 C8.80645161,11.6129032 9.67741935,12.483871 9.67741935,13.5483871 C9.67741935,14.6129032 8.80645161,15.483871 7.74193548,15.483871 L7.74193548,15.483871 Z M10.7419355,6.77419355 L4.74193548,6.77419355 L4.74193548,4.83870968 C4.74193548,3.18387097 6.08709677,1.83870968 7.74193548,1.83870968 C9.39677419,1.83870968 10.7419355,3.18387097 10.7419355,4.83870968 L10.7419355,6.77419355 L10.7419355,6.77419355 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,45 C10.0735931,45 -3.19744231e-14,34.9264069 -3.19744231e-14,23 C-3.19744231e-14,10.0735931 10.0735931,-3.19744231e-14 23,-3.19744231e-14 C34.9264069,-3.19744231e-14 45,10.0735931 45,23 C45,34.9264069 34.9264069,45 23,45 Z M27.9,14.4736842 L27.9,11.7368421 C27.9,10.2178947 26.6985,9 25.2,9 L19.8,9 C18.3015,9 17.1,10.2178947 17.1,11.7368421 L17.1,14.4736842 L11.9931276,14.4736842 C10.3400689,14.4736842 9,15.8107861 9,17.4713097 L9,32.2631579 C9,33.7821053 10.2015,35 11.7,35 L33.3,35 C34.7985,35 36,33.7821053 36,32.2631579 L36,17.4713097 C36,15.8157668 34.6624497,14.4736842 33.0068724,14.4736842 L27.9,14.4736842 Z M20,12 L25,12 L25,15 L20,15 L20,12 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heartrate",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9408016,0 C10.3998301,0 0.203918237,10.0939527 0,22.6349243 L8.41162727,22.6349243 L13.2037058,15.3958269 L18.4546004,27.172105 L25.2348818,7.85085212 L31.8112449,24.6231271 L33.5445499,22.5839447 L45.8816033,22.5839447 C45.677685,10.0939527 35.4817732,0 22.9408016,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4347968,32.4229996 L25.3878205,19.5761507 L18.8624369,38.1836898 L12.489992,23.8584337 L10.6037483,26.713289 L0.305877355,26.713289 C2.09016193,37.5719351 11.5723599,45.8816033 22.9408016,45.8816033 C34.3092433,45.8816033 43.7914413,37.5719351 45.5757259,26.713289 L35.3798141,26.713289 L30.4347968,32.4229996 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "account",
    transform: "translate(-1.000000, -6.000000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9629321,43.6900526 C41.3270622,43.2371343 41.673111,42.7697337 42,42.2888889 C41.9075,36.2873016 29.6358333,33 23.5,33 C17.6648378,33 6.39101924,35.9433673 5.117408,41.344619 C2.52222146,37.7017635 1,33.2737271 1,28.5 C1,16.08 11.304,6 24,6 C36.696,6 47,16.08 47,28.5 C47,34.3530584 44.7116188,39.686434 40.9629321,43.6900526 Z M24.5,12 C19.2433333,12 15,16.02 15,21 C15,25.98 19.2433333,30 24.5,30 C29.7566667,30 34,25.98 34,21 C34,16.02 29.7566667,12 24.5,12 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "exclaim",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L20,20 L0,20 L10,0 Z M10.0007324,18.0014648 C10.5534217,18.0014648 11.0014648,17.5534217 11.0014648,17.0007324 C11.0014648,16.4480432 10.5534217,16 10.0007324,16 C9.44804317,16 9,16.4480432 9,17.0007324 C9,17.5534217 9.44804317,18.0014648 10.0007324,18.0014648 Z M10,6.99316406 C9.44771525,6.99316406 9,7.44087931 9,7.99316406 L9,13 C9,13.5522847 9.44771525,14 10,14 C10.5522847,14 11,13.5522847 11,13 L11,7.99316406 C11,7.44087931 10.5522847,6.99316406 10,6.99316406 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.026,18.886 C44.911467,18.7718599 44.8586526,18.6096975 44.884,18.45 C44.9608764,17.9704859 44.9996643,17.4856374 45,17 C45.0089179,12.78353 42.0824503,9.12898189 37.966,8.216 C37.8164487,8.18230884 37.6904887,8.08213015 37.624,7.944 C35.141919,2.76184244 29.7454394,-0.377554063 24.0137354,0.0262424574 C18.2820313,0.430038978 13.3790084,4.29503178 11.648,9.774 C11.5895895,9.95881325 11.4300024,10.0934892 11.238,10.12 C4.46424718,11.0468004 -0.434105443,17.0619692 0.030296723,23.8830408 C0.494698889,30.7041123 6.16313769,36 13,36 L38,36 C42.0553681,35.9992404 45.7087332,33.5493419 47.248888,29.7978176 C48.7890428,26.0462934 47.910989,21.7360613 45.026,18.886 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "papercut-cloud",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8624562,12.1303503 C17.3683747,10.6331802 18.5603623,7.54819853 17.7459539,4.66757351 C16.9315455,1.7869485 14.3227905,-0.139285209 11.435201,0.00788540139 C8.54761159,0.155056012 6.13303578,2.33731181 5.59418074,5.28690805 C4.14578692,4.56586734 2.41997936,4.83918224 1.24439981,5.97577972 C0.0688202549,7.1123772 -0.316796009,8.88047158 0.272480164,10.4321417 C0.763670626,11.7255345 1.84872483,12.6486974 3.12658244,12.9186646",
    id: "Shape",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,15 L9,15 L8,15 L8,13.6666667 L8,13 L9,13 L10,13 L10,13.6666667 L10,15 Z M12,12.9998712 L12,11 L8,11 C7.6063917,11 7.23982518,11.1138222 6.93007375,11.3100496 C6.68041519,11.4684221 6.46845124,11.6803579 6.31002458,11.9301487 C6.11363016,12.2394257 6,12.6063864 6,12.9998712 L6,15 L6,16.9998712 L6,19 L7.50013657,17.0001288 L8,17.0001288 L10,17.0001288 C11.1046162,17.0001288 12,16.1044872 12,15 L12,12.9998712 Z",
    id: "Fill-1",
    fill: "currentColor",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "os-win",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0040458,3.77754304 C30.6565772,2.4523735 39.3252918,1.20399061 47.9946057,0 C48,7.60427752 47.9946057,15.203156 48,22.8080334 C39.3366798,22.8410276 30.6727603,22.9730047 22.0040458,23 C21.9986514,16.588915 21.9986514,10.183229 22.0040458,3.77754304",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9889677,5 C18.9941935,11.3087318 18.9941935,16.6120627 19,22.9207945 C12.6662796,22.9153937 6.33313978,23.0144083 0,22.9982059 L0,7.69499803 C6.31223642,6.6886494 12.650602,5.81972107 18.9889677,5 Z",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9909325,26.0743208 C18.9909325,32.3824815 19.0071968,37.6912408 18.9961603,44 C12.6710773,43.0340255 6.33553864,42.1895459 0,41.306164 L0,26.0030996 C6.33031082,25.9809552 12.6606216,26.0850937 18.9909325,26.0743208 Z",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9952112,26 C48.005986,33.3317865 47.9952112,40.662993 47.9952112,48 C39.3538851,46.7453596 30.6957983,45.5812065 22.0383101,44.4431555 C22.0275354,38.2975638 22.0107747,32.1513921 22,26 C30.6688615,26 39.3317371,26 47.9952112,26 Z",
    id: "Fill-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "os-mac",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "69453-happy-mac-logo",
    transform: "translate(0.000000, -1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.992353,31.1737961 C12.0175505,30.6529057 11.6545067,29.4438026 12.1800176,28.4747274 C12.7055284,27.5056521 13.9220258,27.1451123 14.8978313,27.6669987 C17.1974426,28.899009 19.7517864,29.6459838 22.367306,29.877048 C22.4956751,27.3662168 22.8928168,25.1900304 23.2739125,23.6144116 L18.0960261,23.6144116 L18.0960261,21.622479 C18.0960261,15.6038544 22.2248966,5.19799811 24,1 L4.01153316,1 C1.80518992,1 0,2.79273941 0,4.98386535 L0,37.0161347 C0,39.2072606 1.80518992,41 4.01153316,41 L23.9638962,41 C23.0693243,38.574822 22.5949605,36.1576117 22.4164473,33.8808326 C19.1179641,33.6487725 15.8896828,32.7275036 12.992353,31.1737961 Z M12,11.7369485 C12,10.7780397 12.6719023,10 13.5,10 C14.3280977,10 15,10.7770293 15,11.7369485 L15,14.2630515 C15,15.2219603 14.3289703,16 13.5,16 C12.6719023,16 12,15.2219603 12,14.2630515 L12,11.7369485 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9722552,1 L28.1383288,1 C27.4613295,2.52777432 22.8865467,13.0150387 22,19.6300824 L28.6118254,19.6300824 L27.5922966,22.3201205 C27.5721478,22.3719095 26.4337412,25.5071334 26.169792,29.8125887 C28.7145842,29.5068346 31.1848258,28.7130692 33.4112671,27.4621667 C34.378409,26.9173866 35.6105075,27.252023 36.159562,28.2091228 C36.709624,29.1652267 36.3711243,30.3812713 35.4039824,30.9250554 C32.5821444,32.5125862 29.4409481,33.4856211 26.2090822,33.8122899 C26.3853841,35.8489904 26.8175756,37.9942484 27.6648322,40.113612 C27.7816952,40.4054229 27.8149407,40.7071932 27.7927771,41 L43.9702404,41 C46.1866072,41 47.9999983,39.2073052 47.9999983,37.0162338 L47.9999983,4.98376615 C48.0020132,2.79269477 46.1886221,1 43.9722552,1 Z M36,14.2630515 C36,15.2219603 35.3274208,16 34.4995638,16 C33.6725792,16 33,15.2219603 33,14.2630515 L33,11.7369485 C33,10.7780397 33.6708345,10 34.4995638,10 C35.3274208,10 36,10.7780397 36,11.7369485 L36,14.2630515 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "os-ios"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,48 C5.96875067,48 0,42.0312507 0,34.6666667 L0,13.3333333 C0,5.96875067 5.96875067,0 13.3333333,0 L34.6666667,0 C42.0312507,0 48,5.96875067 48,13.3333333 L48,34.6666667 C48,42.0312507 42.0312507,48 34.6666667,48 L13.3333333,48 Z M15.2969,24.7339 C15.2969,23.3169 15.5899,22.0419 16.1449,21.0459 C16.9879,19.5339 18.3739,18.7339 20.1509,18.7339 C20.5399,18.7339 20.9219,18.7789 21.3209,18.8729 C22.5239,19.1469 23.4959,19.8919 24.1309,21.0249 C24.6019,21.8679 24.8749,22.9209 24.9429,24.1499 C24.9479,24.2379 24.9559,24.3249 24.9639,24.4109 C24.9739,24.5159 24.9849,24.6219 24.9849,24.7339 C24.9849,25.8899 24.7819,26.9569 24.3839,27.9039 C23.6039,29.7359 22.0999,30.7449 20.1509,30.7449 C19.5589,30.7449 18.9889,30.6389 18.4109,30.4219 C17.3279,30.0119 16.5089,29.2329 15.9789,28.1049 C15.5519,27.1989 15.3269,26.1179 15.3079,24.9009 C15.3079,24.8549 15.3039,24.8119 15.2969,24.7339 Z M13.7349,29.0919 C14.3239,30.3559 15.1859,31.3429 16.2969,32.0259 C17.4319,32.7169 18.7289,33.0679 20.1509,33.0679 C23.7069,33.0679 26.2419,31.0269 27.1059,27.4669 L27.1069,27.4649 C27.3329,26.5209 27.4429,25.6279 27.4429,24.7339 C27.4429,24.3669 27.4099,24.0219 27.3759,23.6789 L27.3569,23.4769 C27.2219,22.1199 26.8919,20.9389 26.3729,19.9659 C25.7039,18.7219 24.7329,17.7799 23.4869,17.1669 C22.4749,16.6659 21.3519,16.4119 20.1509,16.4119 C16.7919,16.4119 14.2959,18.2549 13.3029,21.4699 C12.9949,22.4899 12.8389,23.5879 12.8389,24.7339 C12.8389,24.9199 12.8549,25.0959 12.8709,25.2719 L12.8919,25.5299 C12.9729,26.8649 13.2559,28.0629 13.7349,29.0919 Z M9.5156,16 C8.6796,16 7.9996,16.68 7.9996,17.516 C7.9996,18.352 8.6796,19.031 9.5156,19.031 C10.3546,19.031 11.0366,18.352 11.0366,17.516 C11.0366,16.68 10.3546,16 9.5156,16 Z M35.1201,30.7652 L34.9801,30.7552 C33.4341,30.7202 32.1791,30.0812 31.6631,29.0782 L31.6001,28.9422 C31.4941,28.7092 31.4311,28.4972 31.4091,28.2942 L31.3601,27.8492 L28.9351,27.8492 L28.9751,28.3862 C29.0011,28.7342 29.0721,29.0812 29.1911,29.4402 L29.1691,29.4502 L29.3691,29.9112 C29.3861,29.9522 29.4041,29.9912 29.4221,30.0302 L29.5661,30.3632 L29.5891,30.3532 C30.1961,31.4212 31.2321,32.2402 32.5561,32.6832 C33.3251,32.9382 34.1451,33.0682 34.9951,33.0682 C38.1531,33.0682 40.3971,31.5362 40.8511,29.0702 C40.9141,28.7242 40.9431,28.4512 40.9431,28.1822 C40.9431,26.9882 40.5681,26.0402 39.7981,25.2882 C39.0701,24.5782 38.0051,24.0502 36.4591,23.6412 L36.4601,23.6412 L36.4241,23.6322 C36.3471,23.6122 36.2681,23.5912 36.1891,23.5722 L34.6991,23.1972 C32.4831,22.6442 32.0481,21.9862 31.9161,21.4712 C31.8771,21.3252 31.8591,21.1872 31.8591,21.0362 C31.8591,19.6692 33.1531,18.7132 35.0051,18.7132 C35.9231,18.7132 36.7221,18.9482 37.3161,19.3902 L37.4121,19.4612 C37.8911,19.8512 38.1871,20.3702 38.2701,20.9702 L38.3301,21.4012 L40.7391,21.4012 L40.7021,20.8662 C40.6281,19.8022 40.1641,18.8242 39.3621,18.0402 C38.3001,16.9902 36.7671,16.4112 35.0471,16.4112 C34.2861,16.4112 33.5591,16.5172 32.8901,16.7252 C32.4811,16.8502 32.1001,17.0122 31.7631,17.2032 C30.2621,18.0372 29.4011,19.4492 29.4011,21.0782 C29.4011,21.4892 29.4561,21.8802 29.5771,22.3142 C29.9561,23.6522 30.9591,24.5602 32.7311,25.1692 C33.0571,25.2842 33.4121,25.3872 33.7881,25.4792 L35.5111,25.9172 C36.3961,26.1352 37.0671,26.4052 37.5661,26.7442 C38.1921,27.1622 38.4841,27.6692 38.4841,28.3382 C38.4841,28.7342 38.3591,29.1152 38.1101,29.4712 C37.5491,30.2822 36.4321,30.7652 35.1201,30.7652 Z M8.339,32.7559 L10.703,32.7559 L10.703,20.5369 L8.339,20.5369 L8.339,32.7559 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "os-android",
    transform: "translate(0.000000, 1.000000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,38 L8.55726836,38 C7.69769669,38 7,37.3186397 7,36.4782573 L7,16.5217427 L7,15 L33,15 L33,16.5217427 L33,36.4782573 C33,37.3186397 32.3030816,38 31.4435099,38 L29,38 L29,44.2282834 C29,45.7591711 27.6566472,47 25.9997893,47 C24.3429314,47 23,45.7591711 23,44.2282834 L23,38 L18,38 L18,44.2282834 C18,45.7591711 16.6569743,47 15,47 C13.3434471,47 12,45.7591711 12,44.2282834 L12,38 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,29.2282834 C40,30.7591711 38.8805394,32 37.4998244,32 C36.1191095,32 35,30.7591711 35,29.2282834 L35,16.7721059 C35,15.2412182 36.1191095,14 37.4998244,14 C38.8805394,14 40,15.2412182 40,16.7721059 L40,29.2282834",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,29.2282834 C5,30.7591711 3.88089051,32 2.49982443,32 C1.11946064,32 0,30.7591711 0,29.2282834 L0,16.7721059 C0,15.2412182 1.11946064,14 2.49982443,14 C3.88089051,14 5,15.2412182 5,16.7721059 L5,29.2282834",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13 C0,13 0.289415415,1.96113901 13.0001958,2.00010291 C25.5907455,2.03867716 26,13 26,13 L0,13",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,6.5 C9,7.32845345 8.32807808,8 7.5,8 C6.67154655,8 6,7.32845345 6,6.5 C6,5.67154655 6.67154655,5 7.5,5 C8.32807808,5 9,5.67154655 9,6.5",
    id: "Fill-6",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,6.5 C20,7.32845345 19.3277027,8 18.5,8 C17.6715465,8 17,7.32845345 17,6.5 C17,5.67154655 17.6715465,5 18.5,5 C19.3277027,5 20,5.67154655 20,6.5",
    id: "Fill-7",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50674039,3.96057722 C7.55374686,4.02840136 7.69918567,4.00674666 7.83216977,3.91073057 C7.96314506,3.81634879 8.03224858,3.68356058 7.98524211,3.61573644 L5.4938994,0.0398519327 C5.4460894,-0.0287893604 5.29984706,-0.00631750846 5.16887178,0.0884728487 C5.03628944,0.184080364 4.96758768,0.316051422 5.01499591,0.384692715 L7.50674039,3.96057722",
    id: "Fill-8",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4932255,3.96057722 C19.4462223,4.02840136 19.3011953,4.00674666 19.1678186,3.91073057 C19.0368524,3.81634879 18.9677537,3.68356058 19.0147569,3.61573644 L21.5059273,0.0398519327 C21.553734,-0.0287893604 21.6999662,-0.00631750846 21.8313342,0.0884728487 C21.9639073,0.184080364 22.0326043,0.316051422 21.9847977,0.384692715 L19.4932255,3.96057722",
    id: "Fill-9",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "os-apple",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3431445,3.83212553 C14.1856638,2.81775903 14.7513553,1.40553618 14.5962248,0 C13.3832645,0.0481439606 11.918217,0.805074008 11.048951,1.81810318 C10.2712923,2.71612178 9.5872469,4.1544226 9.77313608,5.53053748 C11.123173,5.63484939 12.5019625,4.84582337 13.3431445,3.83212553 Z M16.3755454,12.7507942 C16.3467927,9.71371273 18.8623147,8.25401459 18.9773252,8.18313598 C17.5490544,6.08753636 15.3437935,5.85550921 14.5668035,5.79867259 C12.5842085,5.65223471 10.9018445,6.90264036 9.96370593,6.90264036 C9.01152537,6.90264036 7.54447191,5.8300999 5.98781718,5.85952121 C3.94437352,5.88961118 2.06074106,7.04506624 1.00759192,8.86851875 C-1.11542301,12.5401644 0.465303693,17.9817693 2.533488,20.9613455 C3.54317384,22.4177003 4.75011619,24.0579383 6.33418623,23.998427 C7.85941365,23.9389158 8.43647251,23.0161565 10.2793163,23.0161565 C12.1221602,23.0161565 12.6417137,23.998427 14.2545364,23.9683371 C15.8954431,23.9389158 16.9358876,22.482561 17.9388867,21.0181821 C19.1010285,19.3284629 19.5791247,17.6915682 19.60654,17.6053103 C19.5697634,17.5932743 16.40831,16.3823199 16.3755454,12.7507942 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "os-linux",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1012,8.5714 C8.6062,9.1924 7.5402,10.2774 6.7512,11.6634 C6.1932,12.6444 5.8412,13.6944 5.6902,14.8124 C5.2762,17.8824 7.2152,20.6444 10.2082,21.2444 C13.4012,21.8844 16.3832,20.1544 17.1842,17.1964 C18.0542,13.9854 16.0422,9.9084 12.9372,8.5914 C13.4232,8.2684 13.9142,7.9524 14.3942,7.6214 C14.9122,7.2634 14.8932,6.7904 14.3302,6.5454 C12.4752,5.7364 10.6032,5.6764 8.7372,6.5034 C8.1302,6.7714 8.0972,7.2314 8.6412,7.6064 C9.1212,7.9374 9.6142,8.2504 10.1012,8.5714 M11.5902,0.0004 C13.6712,0.0864 15.1342,1.0734 15.9812,2.9664 C16.4252,3.9624 16.5492,5.0404 16.7632,6.0954 C16.8452,6.5024 16.9242,6.9114 17.0352,7.3124 C17.2672,8.1574 17.6412,8.9014 18.2602,9.5694 C20.1142,11.5674 21.5612,13.8424 22.6222,16.3594 C22.7412,16.6404 22.8362,16.9234 22.7952,17.2374 C22.7192,17.8044 22.3172,18.1064 21.7562,17.9834 C21.2212,17.8654 20.6852,17.7414 20.1642,17.5754 C19.8142,17.4644 19.7012,17.5814 19.6202,17.9044 C18.4342,22.6104 12.9512,25.2774 8.2502,23.3884 C5.7792,22.3954 4.1642,20.5794 3.4442,18.0114 C3.3052,17.5144 3.1192,17.4204 2.6612,17.5744 C2.1792,17.7384 1.6762,17.8424 1.1792,17.9574 C0.3772,18.1444 -0.1688,17.5954 0.0482,16.7984 C0.1462,16.4364 0.3092,16.0884 0.4702,15.7474 C1.5882,13.3644 3.0542,11.2124 4.8882,9.3294 C5.4742,8.7284 5.8122,8.0524 5.9842,7.2664 C6.1872,6.3434 6.3622,5.4154 6.5532,4.4894 C6.6682,3.9324 6.8352,3.3904 7.0802,2.8764 C7.9852,0.9774 9.5162,0.0604 11.5902,0.0004",
    id: "penguin"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4678,9.456 C10.5498,9.456 9.4198,8.61 8.7448,8.105 C8.6258,8.015 8.5248,7.94 8.4478,7.886 C7.9458,7.541 7.9008,7.17 7.9188,6.979 C7.9368,6.79 8.0488,6.436 8.5988,6.192 C10.4998,5.351 12.4728,5.364 14.4658,6.233 C14.9798,6.457 15.0868,6.804 15.1048,6.991 C15.1378,7.325 14.9538,7.649 14.5878,7.901 C14.5298,7.941 14.4578,7.993 14.3738,8.054 C13.6918,8.544 12.4228,9.456 11.4678,9.456",
    id: "beak",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "os-chrome",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,36.282 C21.5625,36.282 19.344,35.625 17.343,34.314 C15.342,33.0015 13.842,31.314 12.843,29.2515 L3,12 C0.9375,15.6885 0,19.8135 0,24 C0,30 1.953,35.235 5.859,39.7035 C9.765,44.172 14.625,46.8435 20.4375,47.7195 L27.399,35.673 C26.6985,35.8785 25.53,36.282 24,36.282 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4535,14.2965 C18.6705,12.579 21.1875,12 24,12 C24.375,12 44.625,12 44.625,12 C42.4995,8.376 39.609,5.313 35.9535,3.1875 C32.2965,1.0635 28.3125,0 24,0 C20.25,0 16.749,0.7965 13.5,2.391 C10.2495,3.984 7.242,6.3045 5.0385,9.282 L12,21 C12.687,18.3135 14.2335,16.017 16.4535,14.2965 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1955,15 L32.25,15 C34.6875,17.4375 36.282,20.5635 36.282,24 C36.282,26.5635 35.5635,28.9065 34.125,31.032 L24.282,48 C30.8445,47.937 36.438,45.5625 41.064,40.875 C45.687,36.1875 48,30.5625 48,24 C48,20.9385 47.484,17.718 46.1955,15 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24,
    cy: 24,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "printer",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Printers-2.0",
    transform: "translate(-1089.000000, -600.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1069.000000, 580.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333333,33 L13.3333333,34 C13.3333333,35.6568542 14.6764791,37 16.3333333,37 L31.6666667,37 C33.3235209,37 34.6666667,35.6568542 34.6666667,34 L34.6666667,33 L48,33 L48,46 C48,47.1045695 47.1045695,48 46,48 L2,48 C0.8954305,48 1.3527075e-16,47.1045695 0,46 L0,33 L13.3333333,33 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0216029,10 L46,10 C47.1045695,10 48,10.8954305 48,12 L48,15.5 L48,30 L0,30 L0,15.5 L0,10 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,9.33703696 L46.6572465,4.8007493 L47.1069655,6.74953169 L33.0216029,10 Z",
    id: "Combined-Shape"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "papercut",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L18,12 C18,15.3137172 15.3137333,17.9999889 12,18 L12,18 L6,18 L2.66453526e-14,24 L2.66453526e-14,6 C2.66453526e-14,2.68631609 2.68631111,0 6,0 L6,0 L18,0 Z M12,6 L6,6 L6,12 L12,12 L12,6 Z",
    transform: "translate(9.000000, 12.000000) rotate(-360.000000) translate(-9.000000, -12.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "barchart",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 5,
    width: 4,
    height: 17,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9,
    y: 0,
    width: 4,
    height: 22,
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18,
    y: 9,
    width: 4,
    height: 13,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hosted",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 16,
    x2: 11,
    y2: 22,
    id: "Shape",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,13 C22,14.6568542 20.6867019,16 19.0666667,16 L2.93333333,16 C1.31329807,16 0,14.6568542 0,13 C0,11.3431458 1.31329807,10 2.93333333,10 L19.0666667,10 C19.844635,10 20.5907398,10.3160705 21.1408466,10.8786797 C21.6909533,11.4412888 22,12.2043505 22,13 Z",
    id: "Shape",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,7 C22,8.65685425 20.6867019,10 19.0666667,10 L2.93333333,10 C1.31329807,10 0,8.65685425 0,7 C0,5.34314575 1.31329807,4 2.93333333,4 L19.0666667,4 C19.844635,4 20.5907398,4.31607052 21.1408466,4.87867966 C21.6909533,5.44128879 22,6.20435053 22,7 Z",
    id: "Shape",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,4 L1.89591494,2.39482759 C2.67309435,0.916720799 4.14786277,0 5.74846111,0 L15.2476217,0 C16.84822,0 18.3229885,0.916720799 19.1001679,2.39482759 L20,4",
    id: "Shape",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 6,
    y2: 7,
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 13,
    x2: 6,
    y2: 13,
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 22,
    x2: 16,
    y2: 22,
    id: "Shape",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "server",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L48,14 L48,0 L0,0 L0,14 Z M7.5,10 C6.25,10 5,8.75 5,7.5 C5,6.25 6.25,5 7.5,5 C8.75,5 10,6.25 10,7.5 C10,8.75 8.75,10 7.5,10 Z M16.5,10 C15.25,10 14,8.75 14,7.5 C14,6.25 15.25,5 16.5,5 C17.75,5 19,6.25 19,7.5 C19,8.75 17.75,10 16.5,10 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,33 L22,33 L22,38 L19,38 L19,41 L2,41 L2,46 L19,46 L19,48 L22,48 L26,48 L29,48 L29,46 L46,46 L46,41 L29,41 L29,38 L26,38 L26,33 L48,33 L48,19 L0,19 L0,33 Z M17,24 C17.75,24 19,25.25 19,27 C19,28 17.75,29 17,29 C15.25,29 14,28 14,27 C14,25.25 15.25,24 17,24 Z M8,24 C8.75,24 10,25.25 10,27 C10,28 8.75,29 8,29 C6.25,29 5,28 5,27 C5,25.25 6.25,24 8,24 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "subnet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,14 L20,11 C20.0718084,9.900235 19.6364225,9.45871847 19,10 L13,10 L13,8 L16,8 L16,0 L7,0 L7,8 L10,8 L10,10 L4,10 C4.14005345,9.45871847 3.70466755,9.900235 3,11 L3,14 L0,14 L0,22 L9,22 L9,14 L6,14 L6,12 L18,12 L18,14 L15,14 L15,22 L24,22 L24,14 L20,14 Z",
    id: "Shape",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,8.75 L8.75,8.75 L8.75,3.5 L5.25,3.5 L5.25,8.75 L0,8.75 L0,12.25 L5.25,12.25 L5.25,17.5 L8.75,17.5 L8.75,12.25 L14,12.25 L14,8.75 Z M31.5,10.5 C34.405,10.5 36.7325,8.155 36.7325,5.25 C36.7325,2.345 34.405,0 31.5,0 C30.94,0 30.3975,0.0875 29.9075,0.245 C30.905,1.6625 31.4825,3.3775 31.4825,5.25 C31.4825,7.1225 30.8875,8.82 29.9075,10.255 C30.3975,10.4125 30.94,10.5 31.5,10.5 Z M22.75,10.5 C25.655,10.5 27.9825,8.155 27.9825,5.25 C27.9825,2.345 25.655,0 22.75,0 C19.845,0 17.5,2.345 17.5,5.25 C17.5,8.155 19.845,10.5 22.75,10.5 Z M34.335,14.28 C35.7875,15.5575 36.75,17.185 36.75,19.25 L36.75,22.75 L42,22.75 L42,19.25 C42,16.555 37.8525,14.8925 34.335,14.28 Z M22.75,14 C19.25,14 12.25,15.75 12.25,19.25 L12.25,22.75 L33.25,22.75 L33.25,19.25 C33.25,15.75 26.25,14 22.75,14 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "paper-write",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.045,18.636 L9.333,19.166 L9.863,15.454 L19.409,5.908 C20.287685,5.02931496 21.712315,5.02931496 22.591,5.908 C23.469685,6.78668504 23.469685,8.21131496 22.591,9.09 L13.045,18.636 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 5.25,
    y: 0.749,
    width: 7.5,
    height: 3,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75,2.249 L15.75,2.249 C16.5784271,2.249 17.25,2.92057288 17.25,3.749",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25,18.749 L17.25,21.749 C17.25,22.5774271 16.5784271,23.249 15.75,23.249 L2.25,23.249 C1.42157288,23.249 0.75,22.5774271 0.75,21.749 L0.75,3.749 C0.75,2.92057288 1.42157288,2.249 2.25,2.249 L5.25,2.249",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 8.249,
    x2: 12.75,
    y2: 8.249,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.25,
    y1: 12.749,
    x2: 8.25,
    y2: 12.749,
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "download-thick-box",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.001,
    y1: 10.5,
    x2: 12.001,
    y2: 19.5,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "15.001 16.5 12.001 19.5 9.001 16.5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0.751,
    y: 6.75,
    width: 22.5,
    height: 16.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.954,7.5 L3.354,1.641 C3.59487851,1.0988015 4.1327029,0.749529248 4.726,0.749999525 L19.276,0.749999525 C19.8689345,0.749924745 20.4062686,1.09913309 20.647,1.641 L22.991,7.406",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.001,
    y1: 6.75,
    x2: 12.001,
    y2: 0.75,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "email-action-read-document",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,12.88 L19.5,2.25 C19.5,1.42157288 18.8284271,0.75 18,0.75 L6,0.75 C5.17157288,0.75 4.5,1.42157288 4.5,2.25 L4.5,12.88",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.284,11.465 C21.5093503,11.2863025 21.8170422,11.2522091 22.0760466,11.3772383 C22.3350509,11.5022675 22.4997471,11.764397 22.5,12.052 L22.5,21.752 C22.5,22.5804271 21.8284271,23.252 21,23.252 L3,23.252 C2.17157288,23.252 1.5,22.5804271 1.5,21.752 L1.5,12.052 C1.50025291,11.764397 1.66494909,11.5022675 1.92395344,11.3772383 C2.18295779,11.2522091 2.4906497,11.2863025 2.716,11.465 L10.147,17.359 C11.2346554,18.21324 12.7653446,18.21324 13.853,17.359 L21.284,11.465 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 5.25,
    x2: 11.25,
    y2: 5.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 8.25,
    x2: 15.75,
    y2: 8.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 11.25,
    x2: 15.75,
    y2: 11.25,
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "critical-heartbeat",
    fill: "none",
    className: "heartrate",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,10.5 C3.47009988,10.478132 11.0448112,10.478132 24.724134,10.5 L27.224134,7.5 L30.224134,15.5 L32.724134,2 L36.724134,10.5 L43.224134,10.5 L58.8016338,10.5",
    className: "beat",
    stroke: "#CD3100",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "warning-heartbeat",
    fill: "none",
    className: "heartrate",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,12.34879 C3.47009988,12.3269219 8.04481123,12.3773253 15.724134,12.5 L20.224134,7.36316616 L25.224134,15 L30.224134,2 L35.224134,17 L39.224134,7.36316616 L43.224134,12.5 L58.8016338,12.5",
    className: "beat",
    stroke: "#FFCB00",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "good-heartbeat",
    className: "heartrate",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,19.5 C3.47009988,19.478132 8.04481123,19.478132 15.724134,19.5 L20.224134,15.3106924 L25.2161846,24.7188566 L30.1798209,2 L35.1434573,29.7674913 L37.9798209,19.5 L39.224134,15.3106924 L43.224134,19.5 L58.8016338,19.5",
    className: "beat",
    stroke: "#49BB45",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "lanyard",
    className: "lanyard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,1 L1.98828125,24.234375 C6.55940271,17.7992553 14.5306238,11.7266698 24.7031739,6.3046879",
    id: "Path",
    stroke: "#e3e7eb",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "lanyard-bg",
    className: "lanyard-bg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.988281,71.234375 C201.559403,64.7992553 209.530624,58.7266698 219.703174,53.3046879 C269.82434,26.5900437 373.385649,15.6696525 387,55 C396,81 388,140 335,172 C282,204 143.44463,268.796172 70.6835938,270.023438 C41.9108886,270.508749 15.7047293,262.182238 6,240 C-1,224 -5,192 60.7578125,186.246094 C126.515625,180.492188 133.316034,180.667748 160,179 C176,178 271.088937,177.879706 315.972656,145.46875 C345.696421,124.00494 395.028875,59.3300032 364.554688,25.34375 C323,-21 240.85419,11.1593637 214,48 L196.988281,71.234375 Z",
    id: "Path-2",
    stroke: "#e3e7eb",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "thunder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_thunder_2856462",
    transform: "translate(-6.000000, 0.000000)",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.21,10.71 L12.21,23.71 C12.0212812,23.8971865 11.765803,24.0015368 11.5,24.0000167 C11.3127748,24.0006008 11.1291413,23.948629 10.97,23.85 C10.5751562,23.6049602 10.4011447,23.1202138 10.55,22.68 L13.11,15 L7.5,15 C7.109429,15.0009665 6.75403913,14.7744542 6.59,14.42 C6.42643185,14.0646923 6.48503799,13.6466352 6.74,13.35 L17.74,0.35 C18.0360562,0.00254679832 18.5298241,-0.100321504 18.94,0.1 C19.3584301,0.302453146 19.5821844,0.766536295 19.48,1.22 L17.75,9 L24.5,9 C24.9037019,9.00201515 25.2665964,9.24657449 25.42,9.62 C25.5765967,9.9923971 25.4937446,10.4224393 25.21,10.71 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "people-man",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 6,
    r: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.476,3.334 C9.11834331,5.03804894 11.3833412,6.00051057 13.75,6.00000068 C14.9364246,6.00047037 16.1104347,5.7585222 17.2,5.289",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,23.25 C2.25,17.8652237 6.61522369,13.5 12,13.5 C17.3847763,13.5 21.75,17.8652237 21.75,23.25",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,14.249 L8.25,15 C8.25,17.0710678 9.92893219,18.75 12,18.75 C14.0710678,18.75 15.75,17.0710678 15.75,15 L15.75,14.249",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cloud-file",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 11.25,
    y: 11.25,
    width: 12,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 14.25,
    x2: 20.25,
    y2: 14.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 17.25,
    x2: 20.25,
    y2: 17.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.25,
    y1: 20.25,
    x2: 16.5,
    y2: 20.25,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.483,8.25 C21.7722036,7.13477855 20.6380261,6.35698201 19.3416148,6.09570005 C18.0452035,5.83441809 16.6982884,6.11216903 15.611,6.865 C14.8791201,2.96993404 11.2430531,0.316608162 7.31038513,0.807840946 C3.37771717,1.29907373 0.50604674,4.76528644 0.754777073,8.720703 C1.00350741,12.6761196 4.28677417,15.7552884 8.25,15.7500068",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heart-stop",
    transform: "translate(2.000000, 1.500000)",
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.372802734,
    y1: 4,
    x2: 18.3728027,
    y2: 4,
    id: "Path-18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(22.455811, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.42839845,
    y1: 4,
    x2: 19.4283984,
    y2: 4,
    id: "Path-18-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.04418945,
    y1: 0.824684822,
    x2: 1.04418945,
    y2: 6.93604658,
    id: "Path-19"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cloud-hosted",
    stroke: "none",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HiveConnector_AddCust1-Copy-6",
    transform: "translate(-1317.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(1318.327989, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud-Hosted",
    transform: "translate(0.000000, 2.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON-PC-L-Duo_Cloud-Up-Down",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86279294,16.2774414 C4.62021481,16.2774414 2.6234375,16.2358887 1.271289,14.9039551 C0.468310475,14.1122071 0.060644445,13.0430664 0.060644445,11.7257325 C0.060644445,11.4124024 0.09321279,11.0979493 0.157226505,10.7924806 C0.62778316,8.54863287 2.68520504,7.04375 4.91333003,7.18300787 C5.27719716,4.51801765 6.96289062,2.2000489 9.42348628,1.04106453 C13.2923828,-0.7827636 17.9069823,0.785009895 19.8857909,4.53149416 C23.0516601,4.61235353 25.6009765,7.21557622 25.5987318,10.4005371 C25.5987318,15.526123 20.3788084,16.2662109 20.3260253,16.2729492 C20.0183105,16.3178711 19.7240722,16.0921386 19.6825194,15.7776855 C19.6409667,15.4643554 19.8622069,15.1746093 20.1766601,15.1319336 C20.3507323,15.1083496 24.4487304,14.5075194 24.4487304,10.4005371 C24.4509765,7.79956047 22.3374023,5.68149416 19.7375488,5.67924798 L19.55,5.68261713 C19.3220215,5.68935544 19.1086425,5.56132801 19.0109353,5.35244132 C17.4049804,1.94511713 13.3283204,0.47617176 9.91313478,2.08100573 C7.64682621,3.14902338 6.14755856,5.36591794 6.0015625,7.86694335 C5.99145503,8.03427731 5.90947268,8.18813478 5.77695312,8.29033206 C5.64443356,8.39252934 5.47373044,8.42734375 5.30976562,8.3958985 C4.41694334,8.20834959 3.51176754,8.38017581 2.75146482,8.87768559 C1.99003901,9.37519537 1.46894525,10.1388672 1.28251945,11.0283204 C1.23535151,11.2562989 1.21064445,11.4910157 1.21064445,11.7257325 C1.21064445,12.7241212 1.50263658,13.5169922 2.07875967,14.0852539 C3.14790029,15.1386719 4.86616198,15.1375489 4.86728507,15.1274414 C4.87065423,15.1274414 4.87402338,15.1274414 4.87626945,15.1274414 C5.18959948,15.1274414 5.44677731,15.3790039 5.45126945,15.6934571 C5.45576158,16.0112793 5.20195301,16.2729492 4.88525382,16.2774414 C4.88076169,16.2774414 4.87402338,16.2774414 4.86279294,16.2774414 Z",
    id: "Path"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(8.396484, 7.500000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97095353,12.696818 L8.97095353,1.06546725 C8.97095353,0.477025935 8.63835987,0 8.28632813,0 L0.637409856,0 C0.285378113,0 0,0.477025935 0,1.06546725 L0,12.785607 C0,13.3740483 0.285378113,13.8510742 0.637409856,13.8510742 L8.49879808,13.8510742 L8.97095353,12.696818 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 8.98258273,
    y1: 12.7101237,
    x2: 17.2143555,
    y2: 12.7101237,
    id: "Line",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.98258273,
    y1: 16.8932292,
    x2: 17.2143555,
    y2: 16.8932292,
    id: "Line-Copy",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "edge-mesh"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2,
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10,
    x2: 45,
    y2: 4,
    id: "Path-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 29,
    x2: 44,
    y2: 4,
    id: "Path-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 44,
    x2: 44,
    y2: 4,
    id: "Path-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 30,
    x2: 44.122449,
    y2: 3.91836735,
    id: "Path-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10,
    x2: 43,
    y2: 29,
    id: "Path-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10,
    x2: 23,
    y2: 44,
    id: "Path-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.7959184,
    y1: 9.79591837,
    x2: 5,
    y2: 29,
    id: "Path-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 29,
    x2: 44,
    y2: 29,
    id: "Path-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 29,
    x2: 23,
    y2: 44,
    id: "Path-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.122449,
    y1: 30.3673469,
    x2: 23,
    y2: 44,
    id: "Path-23"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    strokeWidth: 2,
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 29,
    r: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    strokeWidth: 2,
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 29,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 23,
    cy: 44,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 10,
    r: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "hive",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4608696,27.4369565 C22.148913,27.4369565 21.8369565,27.3608696 21.5478261,27.1934783 C20.6728261,26.6913043 20.376087,25.5728261 20.8782609,24.6978261 L27.201087,13.7413043 L25.8163043,11.3445652 C25.3141304,10.4695652 25.6108696,9.35108696 26.4858696,8.84891304 C27.3608696,8.34673913 28.4793478,8.64347826 28.9815217,9.51847826 L30.8913043,12.8282609 C31.2184783,13.3913043 31.2184783,14.0913043 30.8913043,14.6543478 L24.0358696,26.523913 C23.701087,27.1097826 23.0923913,27.4369565 22.4608696,27.4369565 Z",
    id: "Path",
    fill: "#8EC741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0978261,4.51195652 L24.0434783,0.958695652 C23.7163043,0.395652174 23.1152174,0.0456521739 22.4608696,0.0456521739 L18.3597826,0.0456521739 C17.5304348,0.0456521739 16.8076087,0.601086957 16.5945652,1.4 C16.3815217,2.19891304 16.7315217,3.04347826 17.4467391,3.45434783 L23.6021739,7.0076087 C23.8836957,7.175 24.2032609,7.25108696 24.5152174,7.25108696 C24.9869565,7.25108696 25.4586957,7.06847826 25.8086957,6.71847826 C26.3869565,6.1326087 26.5086957,5.22717391 26.0978261,4.51195652 Z",
    id: "Path",
    fill: "#33C2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4608696,27.4369565 L8.7576087,27.4369565 C8.10326087,27.4369565 7.50217391,27.0869565 7.175,26.523913 L0.319565217,14.6543478 C-0.00760869565,14.0913043 -0.00760869565,13.3913043 0.319565217,12.8282609 L7.175,0.958695652 C7.50217391,0.395652174 8.10326087,0.0456521739 8.7576087,0.0456521739 L12.5771739,0.0456521739 C13.5891304,0.0456521739 14.4032609,0.859782609 14.4032609,1.87173913 C14.4032609,2.88369565 13.5891304,3.69782609 12.5771739,3.69782609 L9.81521739,3.69782609 L4.0173913,13.7413043 L9.81521739,23.7847826 L22.4684783,23.7847826 C23.4804348,23.7847826 24.2945652,24.598913 24.2945652,25.6108696 C24.2945652,26.6228261 23.4728261,27.4369565 22.4608696,27.4369565 Z",
    id: "Path",
    fill: "#27AA27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pocket",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.492188,0.65625 C23.320312,0.257812 22.929688,0 22.5,0 L7.5,0 C7.070312,0 6.679688,0.257812 6.507812,0.65625 C6.339844,1.058594 6.429688,1.511719 6.730469,1.8125 L14.230469,9.421875 C14.4375,9.625 14.707031,9.742188 15,9.742188 C15.292969,9.742188 15.5625,9.625 15.769531,9.421875 L23.269531,1.8125 C23.5625,1.511719 23.652344,1.050781 23.492188,0.65625 Z",
    id: "Path",
    fill: "#33C2AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.429688,28.4375 C20.6875,28.4375 19.972656,28.054688 19.570312,27.378906 C18.972656,26.363281 19.320312,25.058594 20.339844,24.460938 L25.707031,21.34375 L25.707031,2.132812 C25.707031,0.949219 26.660156,0 27.847656,0 C29.035156,0 29.992188,0.949219 29.992188,2.132812 L29.992188,21.957031 C29.992188,23.09375 29.382812,24.152344 28.394531,24.71875 L22.5,28.140625 C22.167969,28.335938 21.792969,28.4375 21.429688,28.4375 Z",
    id: "Path",
    fill: "#8EC741"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,32 C14.4375,32 13.882812,31.859375 13.382812,31.5625 L1.597656,24.71875 C0.605469,24.152344 0,23.09375 0,21.957031 L0,2.132812 C0,0.949219 0.957031,0 2.144531,0 C3.332031,0 4.285156,0.949219 4.285156,2.132812 L4.285156,21.34375 L15,27.5625 L20.347656,24.460938 C21.367188,23.867188 22.679688,24.214844 23.277344,25.226562 C23.875,26.238281 23.527344,27.546875 22.507812,28.140625 L16.617188,31.5625 C16.117188,31.859375 15.5625,32 15,32 Z",
    id: "Path",
    fill: "#27AA27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "magic",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875,11.25 L18,21.65 C18.0277193,22.0648487 17.8820079,22.472593 17.5976431,22.7759154 C17.3132783,23.0792378 16.9157727,23.250925 16.5,23.25 L6,23.25 C5.58422725,23.250925 5.18672169,23.0792378 4.9023569,22.7759154 C4.61799211,22.472593 4.47228072,22.0648487 4.5,21.65 L5.622,11.25",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.279,
    y1: 15,
    x2: 5.221,
    y2: 15,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 11.25,
    x2: 21,
    y2: 11.25,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 0.75,
    x2: 12,
    y2: 7.5,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.25,
    y1: 2.25,
    x2: 5.25,
    y2: 2.25,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.75,
    y1: 0.75,
    x2: 3.75,
    y2: 3.75,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6.75,
    x2: 9,
    y2: 6.75,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 5.25,
    x2: 7.5,
    y2: 8.25,
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "no-bell",
    transform: "translate(1.000000, 1.000000)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41390228,0.53670311 C5.90314818,0.336390205 7.31157657,0 7.875,0 C10.1531746,0 12,1.80895051 12,4.04040404 C12,4.71380471 12,5.21885522 12,5.55555556 M5.25,10 C4.08333333,10 2.33333333,10 0,10 C0.911269837,10 1.65,9.2764198 1.65,8.38383838 L1.65,5.66666667",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.375,13 C7.16789322,13 7,13.1678932 7,13.375 C7,13.5821068 7.16789322,13.75 7.375,13.75 C7.58210678,13.75 7.75,13.5821068 7.75,13.375 C7.75,13.1678932 7.58210678,13 7.375,13 L7.375,13",
    id: "Shape",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 14,
    y2: 12,
    id: "Line",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "encrypt",
    transform: "translate(1.000000, 1.000000)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C14.1864375,0 16.1669956,0.86414526 17.6008857,2.26093322 C19.0347758,3.65772116 19.921875,5.58703197 19.921875,7.71689499 L19.921875,7.71689499 L19.921875,9.26940641 C21.2132812,9.26940641 22.1749352,9.68945937 22.8718623,10.3683533 C23.5687893,11.0472472 24,11.9840183 24,13.0136986 L24,13.0136986 L24,26.2557078 C24,27.2853882 23.5687893,28.2221592 22.8718623,28.9010531 C22.1749352,29.5799471 21.2132812,30 20.15625,30 L20.15625,30 L3.84375,30 C2.78671875,30 1.82506474,29.5799471 1.12813769,28.9010531 C0.431210632,28.2221592 0,27.2853882 0,26.2557078 L0,26.2557078 L0,13.0136986 C0,11.9840183 0.431210632,11.0472472 1.12813769,10.3683533 C1.82506474,9.68945937 2.78671875,9.26940641 3.84375,9.26940641 L3.84375,9.26940641 L4.07812499,7.71689499 C4.07812499,5.58703197 4.96522411,3.65772116 6.39911424,2.26093322 C7.83300438,0.86414526 9.81356249,0 12,0 Z M12,5 C11.1725807,5 10.4227854,5.37010874 9.87971076,5.96718281 C9.33663606,6.56425689 9,7.38860634 9,8.29829829 L9,10 L15,10 L15,8.29829829 C15,7.38860634 14.6633639,6.56425689 14.1202892,5.96718281 C13.5772146,5.37010874 12.8274193,5 12,5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 24,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 24,
    id: "Line",
    transform: "translate(12.000000, 19.000000) rotate(-90.000000) translate(-12.000000, -19.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(1.000000, 2.000000)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "30 12 0 12 0 18 30 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.33671038 0 3 2.57417093 1.66328961 0 1.33756862 0.209249933 2.67502944 2.78486602 0 2.78486602 0 3.20243951 2.67063615 3.20243951 1.33566419 5.79075126 1.66138333 6 3 3.40462171 4.33861666 6 4.66433582 5.79075126 3.32936385 3.20243951 6 3.20243951 6 2.78486602 3.32497055 2.78486602 4.66243138 0.209249933"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.3367104 0 15 2.57417093 13.6632896 0 13.3375686 0.209249933 14.6750294 2.78486602 12 2.78486602 12 3.20243951 14.6706361 3.20243951 13.3356642 5.79075126 13.6613833 6 15 3.40462171 16.3386167 6 16.6643358 5.79075126 15.3293639 3.20243951 18 3.20243951 18 2.78486602 15.3249706 2.78486602 16.6624314 0.209249933"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "28.3367104 0 27 2.57417093 25.6632896 0 25.3375686 0.209249933 26.6750294 2.78486602 24 2.78486602 24 3.20243951 26.6706361 3.20243951 25.3356642 5.79075126 25.6613833 6 27 3.40462171 28.3386167 6 28.6643358 5.79075126 27.3293639 3.20243951 30 3.20243951 30 2.78486602 27.3249706 2.78486602 28.6624314 0.209249933"
  })), /*#__PURE__*/React.createElement("g", {
    id: "disabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-3",
    fill: "#AEAFB1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(8.834930, 8.688571) rotate(-315.000000) translate(-8.834930, -8.688571) ",
    points: "13.8942474 9.96985848 10.1017972 9.96174628 10.1099094 13.7541965 7.5816092 13.7487884 7.573497 9.95633816 3.78104675 9.94822596 3.77561158 7.40728429 7.56806184 7.41539648 7.55994964 3.62294622 10.0882498 3.62835435 10.096362 7.42080461 13.8888123 7.4289168"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "enabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-4",
    fill: "#05B054"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    points: "12.4521599 5.909961 7.34496368 10.5586553 4.87944996 8.08849499 4.04778145 8.92372906 7.34496368 12.2350471 13.6220776 6.29385587 12.8421324 5.51056692"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bell"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1429 1.85711C10.4197 1.85711 8.76713 2.54163 7.54868 3.76008C6.33023 4.97853 5.64571 6.6311 5.64571 8.35425C5.64571 12.5273 4.88894 15.1419 3.94057 16.745C3.82539 16.9397 3.70724 17.1196 3.58716 17.2857H20.7016C20.583 17.1219 20.4663 16.9445 20.3523 16.7527C19.4012 15.1514 18.64 12.5364 18.64 8.35425C18.64 6.6311 17.9555 4.97853 16.737 3.76008C15.5186 2.54163 13.866 1.85711 12.1429 1.85711ZM12.1429 0.142822C9.96505 0.142822 7.87644 1.00795 6.3365 2.54789C4.79655 4.08784 3.93142 6.17644 3.93142 8.35425C3.93142 12.3412 3.20533 14.6209 2.46514 15.8721C2.09617 16.4958 1.72636 16.8602 1.44216 17.0625C1.19243 17.2402 1.03433 17.2765 1.00249 17.2839C0.995562 17.2855 0.994612 17.2857 0.999996 17.2857C0.526609 17.2857 0.142853 17.6694 0.142853 18.1428C0.142853 18.6162 0.526609 19 0.999996 19H23.2857C23.7591 19 24.1429 18.6162 24.1429 18.1428C24.1429 17.6694 23.7591 17.2857 23.2857 17.2857C23.2925 17.2857 23.2916 17.2855 23.2836 17.2835C23.2504 17.2755 23.0948 17.2381 22.8499 17.0642C22.5662 16.8629 22.196 16.4997 21.8262 15.8772C21.0845 14.6285 20.3543 12.3493 20.3543 8.35425C20.3543 6.17644 19.4892 4.08784 17.9492 2.54789C16.4093 1.00795 14.3207 0.142822 12.1429 0.142822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35547 20.4505C9.81359 20.3312 10.2817 20.6059 10.4009 21.064C10.5013 21.4496 10.7268 21.791 11.042 22.0346C11.3572 22.2783 11.7444 22.4105 12.1429 22.4105C12.5413 22.4105 12.9285 22.2783 13.2437 22.0346C13.5589 21.791 13.7844 21.4496 13.8848 21.064C14.0041 20.6059 14.4721 20.3312 14.9302 20.4505C15.3884 20.5697 15.663 21.0378 15.5438 21.4959C15.3478 22.2487 14.9076 22.9152 14.2921 23.391C13.6767 23.8667 12.9207 24.1248 12.1429 24.1248C11.365 24.1248 10.609 23.8667 9.99359 23.391C9.37814 22.9152 8.93792 22.2487 8.74193 21.4959C8.62267 21.0378 8.89736 20.5697 9.35547 20.4505Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "circled-plus",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11 6.875 0 8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.875 11 8.25 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6875 11a10.3125 10.3125 0 1 0 20.625 0 10.3125 10.3125 0 1 0 -20.625 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hyperlink",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.583666666666668 16.958333333333332 -0.8543333333333334 0.8543333333333334a4.125 4.125 0 0 1 -5.833666666666666 -5.833666666666666l4.375249999999999 -4.376166666666666a4.125 4.125 0 0 1 6.25625 5.339583333333334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.583166666666665 5.103083333333333 0.6875 -0.6875a4.125 4.125 0 0 1 5.833666666666666 5.833666666666666l-4.375249999999999 4.375249999999999a4.125 4.125 0 0 1 -6.255333333333333 -5.3405"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    className: "duo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 21.75a1.5 1.5 0 0 1 -1.5 1.5H2.25a1.5 1.5 0 0 1 0 -3h19.5a1.5 1.5 0 0 1 1.5 1.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6h4V4.75a1.75 1.75 0 0 1 3.5 0v3.462a1 1 0 0 1 -0.767 0.972L16 10.5v3l3 6.75h-3.307l-3.693 -5 -3.693 5H5l3 -6.75v-3L2.517 9.184a1 1 0 0 1 -0.767 -0.972V4.75a1.75 1.75 0 0 1 3.5 0V6h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 6 12 7.25 9.25 6V3.5a2.75 2.75 0 0 1 5.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.244 9.839 -3.018 6.159 4.664 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.756 9.839 3.018 6.159 -4.664 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 12.25 8 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.25 3.5 5.5 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.3eff9484fd790da08ffb9e74df607cb4.svg";
export { ForwardRef as ReactComponent };